/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type __SubscriptionContainer = {
  onCreateRoom: OnCreateRoomSubscription;
  onUpdateRoom: OnUpdateRoomSubscription;
  onDeleteRoom: OnDeleteRoomSubscription;
  onCreateRoomType: OnCreateRoomTypeSubscription;
  onUpdateRoomType: OnUpdateRoomTypeSubscription;
  onDeleteRoomType: OnDeleteRoomTypeSubscription;
  onCreateReservationPost: OnCreateReservationPostSubscription;
  onUpdateReservationPost: OnUpdateReservationPostSubscription;
  onDeleteReservationPost: OnDeleteReservationPostSubscription;
  onCreateCapture: OnCreateCaptureSubscription;
  onUpdateCapture: OnUpdateCaptureSubscription;
  onDeleteCapture: OnDeleteCaptureSubscription;
  onCreateNode: OnCreateNodeSubscription;
  onUpdateNode: OnUpdateNodeSubscription;
  onDeleteNode: OnDeleteNodeSubscription;
  onCreateSpace: OnCreateSpaceSubscription;
  onUpdateSpace: OnUpdateSpaceSubscription;
  onDeleteSpace: OnDeleteSpaceSubscription;
  onCreateZone: OnCreateZoneSubscription;
  onUpdateZone: OnUpdateZoneSubscription;
  onDeleteZone: OnDeleteZoneSubscription;
  onCreateLayer: OnCreateLayerSubscription;
  onUpdateLayer: OnUpdateLayerSubscription;
  onDeleteLayer: OnDeleteLayerSubscription;
  onCreateNavigation: OnCreateNavigationSubscription;
  onUpdateNavigation: OnUpdateNavigationSubscription;
  onDeleteNavigation: OnDeleteNavigationSubscription;
  onCreatePOI: OnCreatePOISubscription;
  onUpdatePOI: OnUpdatePOISubscription;
  onDeletePOI: OnDeletePOISubscription;
  onCreatePlan: OnCreatePlanSubscription;
  onUpdatePlan: OnUpdatePlanSubscription;
  onDeletePlan: OnDeletePlanSubscription;
  onCreateProfile: OnCreateProfileSubscription;
  onUpdateProfile: OnUpdateProfileSubscription;
  onDeleteProfile: OnDeleteProfileSubscription;
  onCreateOrganisation: OnCreateOrganisationSubscription;
  onUpdateOrganisation: OnUpdateOrganisationSubscription;
  onDeleteOrganisation: OnDeleteOrganisationSubscription;
  onCreateMission: OnCreateMissionSubscription;
  onUpdateMission: OnUpdateMissionSubscription;
  onDeleteMission: OnDeleteMissionSubscription;
};

export type CreateRoomInput = {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  externalID?: string | null;
  internalRoomType?: RoomTypeVRRoom | null;
};

export enum RoomTypeVRRoom {
  CLASSIC_ROOM = "CLASSIC_ROOM",
  MEETING_ROOM = "MEETING_ROOM",
  INFORMATION = "INFORMATION",
  COMMON_SPACE = "COMMON_SPACE",
}

export type ModelRoomConditionInput = {
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  externalID?: ModelStringInput | null;
  internalRoomType?: ModelRoomTypeVRRoomInput | null;
  and?: Array<ModelRoomConditionInput | null> | null;
  or?: Array<ModelRoomConditionInput | null> | null;
  not?: ModelRoomConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelRoomTypeVRRoomInput = {
  eq?: RoomTypeVRRoom | null;
  ne?: RoomTypeVRRoom | null;
};

export type Room = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: Space | null;
  externalID?: string | null;
  pois?: ModelPOIConnection | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type Space = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  zones?: ModelZoneConnection | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<DataPerLocale | null> | null;
  createdAt: string;
  updatedAt: string;
};

export enum LevelStatus {
  MINIMUM = "MINIMUM",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
  MAXIMUM = "MAXIMUM"
}

export type Organisation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelZoneConnection = {
  __typename: "ModelZoneConnection";
  items: Array<Zone | null>;
  nextToken?: string | null;
};

export type Zone = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: Zone | null;
  spaceID?: string | null;
  space?: Space | null;
  layerID?: string | null;
  layer?: Layer | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type Layer = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: Organisation | null;
  createdAt: string;
  updatedAt: string;
};

export type DataPerLocale = {
  __typename: "DataPerLocale";
  locale?: Locale | null;
  data?: string | null;
};

export enum Locale {
  FR = "FR",
  EN = "EN"
}

export type ModelPOIConnection = {
  __typename: "ModelPOIConnection";
  items: Array<POI | null>;
  nextToken?: string | null;
};

export type POI = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum PoiType {
  EQUIPMENT = "EQUIPMENT",
  INFORMATION = "INFORMATION",
  TICKET = "TICKET",
  MEASURE = "MEASURE",
  DATA = "DATA",
  PEOPLE = "PEOPLE",
  DESK = "DESK",
  ROOM = "ROOM"
}

export enum RoleStatus {
  VISITOR = "VISITOR",
  VISITOR_MUSEUM = "VISITOR_MUSEUM",
  GUIDE_MUSEUM = "GUIDE_MUSEUM",
  OCCUPANT = "OCCUPANT",
  SERVICE = "SERVICE",
  MANAGER = "MANAGER",
  OWNER = "OWNER",
  ADMIN = "ADMIN"
}

export type UpdateRoomInput = {
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID?: string | null;
  externalID?: string | null;
  internalRoomType?: RoomTypeVRRoom | null;
};

export type DeleteRoomInput = {
  id: string;
};

export type CreateRoomTypeInput = {
  id?: string | null;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
};

export type ModelRoomTypeConditionInput = {
  externalID?: ModelIntInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  nbPersonsMin?: ModelIntInput | null;
  nbPersonsMax?: ModelIntInput | null;
  and?: Array<ModelRoomTypeConditionInput | null> | null;
  or?: Array<ModelRoomTypeConditionInput | null> | null;
  not?: ModelRoomTypeConditionInput | null;
};

export type ModelIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type RoomType = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: Space | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateRoomTypeInput = {
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID?: string | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
};

export type DeleteRoomTypeInput = {
  id: string;
};

export type CreateReservationPostInput = {
  id?: string | null;
  externalID?: number | null;
  reservationThais?: ReservationThaisInput | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
};

export type ReservationThaisInput = {
  checkin?: string | null;
  checkout?: string | null;
  comment?: string | null;
  customer_civility_id?: number | null;
  customer_firstname?: string | null;
  customer_lastname?: string | null;
  customer_email?: string | null;
  customer_phone?: string | null;
  customer_mobile?: string | null;
  customer_zipcode?: string | null;
  customer_city?: string | null;
  customer_address?: string | null;
  customer_country?: string | null;
  channel_name?: string | null;
  payment_type?: string | null;
  payment_amount?: number | null;
  insurance_amount?: number | null;
  booking_rooms?: Array<BookingRoomInput | null> | null;
};

export type BookingRoomInput = {
  room_id?: number | null;
  room_type_id?: number | null;
  rate_id?: number | null;
  price?: number | null;
  nb_persons?: NumberPersonsInput | null;
  extras?: Array<ExtraReservationInput | null> | null;
};

export type NumberPersonsInput = {
  adults?: number | null;
  children?: number | null;
};

export type ExtraReservationInput = {
  article_id?: number | null;
  label?: string | null;
  quantity?: number | null;
  unit_price_incl?: number | null;
  date?: string | null;
};

export enum StripePaymentStatus {
  SESSION_EXPIRED = "SESSION_EXPIRED",
  PAID = "PAID",
  SESSION_CREATED = "SESSION_CREATED",
  ERROR = "ERROR"
}

export type ModelReservationPostConditionInput = {
  externalID?: ModelIntInput | null;
  roomThais?: ModelStringInput | null;
  stripeSessionID?: ModelStringInput | null;
  stripePaymentStatus?: ModelStripePaymentStatusInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelReservationPostConditionInput | null> | null;
  or?: Array<ModelReservationPostConditionInput | null> | null;
  not?: ModelReservationPostConditionInput | null;
};

export type ModelStripePaymentStatusInput = {
  eq?: StripePaymentStatus | null;
  ne?: StripePaymentStatus | null;
};

export type ReservationPost = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: ReservationThais | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: Space | null;
  createdAt: string;
  updatedAt: string;
};

export type ReservationThais = {
  __typename: "ReservationThais";
  checkin?: string | null;
  checkout?: string | null;
  comment?: string | null;
  customer_civility_id?: number | null;
  customer_firstname?: string | null;
  customer_lastname?: string | null;
  customer_email?: string | null;
  customer_phone?: string | null;
  customer_mobile?: string | null;
  customer_zipcode?: string | null;
  customer_city?: string | null;
  customer_address?: string | null;
  customer_country?: string | null;
  channel_name?: string | null;
  payment_type?: string | null;
  payment_amount?: number | null;
  insurance_amount?: number | null;
  booking_rooms?: Array<BookingRoom | null> | null;
};

export type BookingRoom = {
  __typename: "BookingRoom";
  room_id?: number | null;
  room_type_id?: number | null;
  rate_id?: number | null;
  price?: number | null;
  nb_persons?: NumberPersons | null;
  extras?: Array<ExtraReservation | null> | null;
};

export type NumberPersons = {
  __typename: "NumberPersons";
  adults?: number | null;
  children?: number | null;
};

export type ExtraReservation = {
  __typename: "ExtraReservation";
  article_id?: number | null;
  label?: string | null;
  quantity?: number | null;
  unit_price_incl?: number | null;
  date?: string | null;
};

export type UpdateReservationPostInput = {
  id: string;
  externalID?: number | null;
  reservationThais?: ReservationThaisInput | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
};

export type DeleteReservationPostInput = {
  id: string;
};

export type CreateCaptureInput = {
  id?: string | null;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
};

export enum CaptureViewer {
  CUPIX = "CUPIX",
  MATTERPORT = "MATTERPORT",
  SMARTERPLAN_V1 = "SMARTERPLAN_V1"
}

export type ModelCaptureConditionInput = {
  clientRef?: ModelStringInput | null;
  originCoordinate?: ModelStringInput | null;
  originAngle?: ModelStringInput | null;
  originZoom?: ModelStringInput | null;
  takenAt?: ModelIntInput | null;
  viewer?: ModelCaptureViewerInput | null;
  publishedAt?: ModelIntInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelCaptureConditionInput | null> | null;
  or?: Array<ModelCaptureConditionInput | null> | null;
  not?: ModelCaptureConditionInput | null;
};

export type ModelCaptureViewerInput = {
  eq?: CaptureViewer | null;
  ne?: CaptureViewer | null;
};

export type Capture = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: ModelNodeConnection | null;
  createdAt: string;
  updatedAt: string;
};

export type ModelNodeConnection = {
  __typename: "ModelNodeConnection";
  items: Array<Node | null>;
  nextToken?: string | null;
};

export type Node = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: Capture | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum NodeQuality {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH"
}

export enum InventoryStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  TO_RUN = "TO_RUN",
  TO_RUN_ONE_IMAGE = "TO_RUN_ONE_IMAGE",
  ERROR_FILE_OBJ_NOT_EXIST = "ERROR_FILE_OBJ_NOT_EXIST",
  ERROR_FILE_JSON_NOT_EXIST = "ERROR_FILE_JSON_NOT_EXIST",
  ERROR_FILE_MODEL_NOT_EXIST = "ERROR_FILE_MODEL_NOT_EXIST"
}

export type UpdateCaptureInput = {
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
};

export type DeleteCaptureInput = {
  id: string;
};

export type CreateNodeInput = {
  id?: string | null;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
};

export type ModelNodeConditionInput = {
  model3D?: ModelStringInput | null;
  coordinate?: ModelStringInput | null;
  size?: ModelStringInput | null;
  scale?: ModelStringInput | null;
  version?: ModelIntInput | null;
  active?: ModelIntInput | null;
  order?: ModelIntInput | null;
  quality?: ModelNodeQualityInput | null;
  metadata?: ModelStringInput | null;
  captureID?: ModelIDInput | null;
  inventoryStatus?: ModelInventoryStatusInput | null;
  navigationForInventory?: ModelStringInput | null;
  and?: Array<ModelNodeConditionInput | null> | null;
  or?: Array<ModelNodeConditionInput | null> | null;
  not?: ModelNodeConditionInput | null;
};

export type ModelNodeQualityInput = {
  eq?: NodeQuality | null;
  ne?: NodeQuality | null;
};

export type ModelInventoryStatusInput = {
  eq?: InventoryStatus | null;
  ne?: InventoryStatus | null;
};

export type UpdateNodeInput = {
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
};

export type DeleteNodeInput = {
  id: string;
};

export type CreateSpaceInput = {
  id?: string | null;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<DataPerLocaleInput | null> | null;
};

export type DataPerLocaleInput = {
  locale?: Locale | null;
  data?: string | null;
};

export type ModelSpaceConditionInput = {
  name?: ModelStringInput | null;
  addresses?: ModelStringInput | null;
  annexes?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  latitude?: ModelFloatInput | null;
  longitude?: ModelFloatInput | null;
  metadata?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  deletedAt?: ModelIntInput | null;
  organisationID?: ModelIDInput | null;
  guestLink?: ModelStringInput | null;
  description?: ModelStringInput | null;
  primaryColor?: ModelStringInput | null;
  connectedAccountStripeID?: ModelStringInput | null;
  stripeOnBoardingCompleted?: ModelBooleanInput | null;
  stripeChargesEnabled?: ModelBooleanInput | null;
  contactMail?: ModelStringInput | null;
  contactPhone?: ModelStringInput | null;
  contactSiteWeb?: ModelStringInput | null;
  pmsMetadata?: ModelStringInput | null;
  pmsName?: ModelStringInput | null;
  and?: Array<ModelSpaceConditionInput | null> | null;
  or?: Array<ModelSpaceConditionInput | null> | null;
  not?: ModelSpaceConditionInput | null;
};

export type ModelFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type ModelLevelStatusInput = {
  eq?: LevelStatus | null;
  ne?: LevelStatus | null;
};

export type ModelBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
};

export type UpdateSpaceInput = {
  id: string;
  name?: string | null;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<DataPerLocaleInput | null> | null;
};

export type DeleteSpaceInput = {
  id: string;
};

export type CreateZoneInput = {
  id?: string | null;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  spaceID?: string | null;
  layerID?: string | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
};

export type ModelZoneConditionInput = {
  name?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  parentID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  layerID?: ModelIDInput | null;
  isMuseumVisitZone?: ModelBooleanInput | null;
  sweepIDs?: ModelStringInput | null;
  nodeIDs?: ModelStringInput | null;
  isMultipleFloorZone?: ModelBooleanInput | null;
  and?: Array<ModelZoneConditionInput | null> | null;
  or?: Array<ModelZoneConditionInput | null> | null;
  not?: ModelZoneConditionInput | null;
};

export type UpdateZoneInput = {
  id: string;
  name?: string | null;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  spaceID?: string | null;
  layerID?: string | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
};

export type DeleteZoneInput = {
  id: string;
};

export type CreateLayerInput = {
  id?: string | null;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
};

export type ModelLayerConditionInput = {
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelLayerConditionInput | null> | null;
  or?: Array<ModelLayerConditionInput | null> | null;
  not?: ModelLayerConditionInput | null;
};

export type UpdateLayerInput = {
  id: string;
  name?: string | null;
  slug?: string | null;
  organisationID?: string | null;
};

export type DeleteLayerInput = {
  id: string;
};

export type CreateNavigationInput = {
  id?: string | null;
  matterportSweepID?: string | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
};

export type ModelNavigationConditionInput = {
  matterportSweepID?: ModelStringInput | null;
  position?: ModelStringInput | null;
  rotation?: ModelStringInput | null;
  radius?: ModelIntInput | null;
  url?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  nodeID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  positionOnPlan?: ModelStringInput | null;
  and?: Array<ModelNavigationConditionInput | null> | null;
  or?: Array<ModelNavigationConditionInput | null> | null;
  not?: ModelNavigationConditionInput | null;
};

export type Navigation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<Navigation | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: Node | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateNavigationInput = {
  id: string;
  matterportSweepID?: string | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
};

export type DeleteNavigationInput = {
  id: string;
};

export type CreatePOIInput = {
  id?: string | null;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
};

export type ModelPOIConditionInput = {
  coordinate?: ModelStringInput | null;
  specific?: ModelBooleanInput | null;
  private?: ModelBooleanInput | null;
  global?: ModelBooleanInput | null;
  type?: ModelPoiTypeInput | null;
  elementID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  category?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  tagIcon?: ModelStringInput | null;
  tagDescription?: ModelStringInput | null;
  tagImageID?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  and?: Array<ModelPOIConditionInput | null> | null;
  or?: Array<ModelPOIConditionInput | null> | null;
  not?: ModelPOIConditionInput | null;
};

export type ModelPoiTypeInput = {
  eq?: PoiType | null;
  ne?: PoiType | null;
};

export type ModelRoleStatusInput = {
  eq?: RoleStatus | null;
  ne?: RoleStatus | null;
};

export type UpdatePOIInput = {
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
};

export type DeletePOIInput = {
  id: string;
};

export type CreatePlanInput = {
  id?: string | null;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
};

export type ModelPlanConditionInput = {
  name?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  calibration?: ModelStringInput | null;
  zoneID?: ModelIDInput | null;
  isCurrentForZone?: ModelBooleanInput | null;
  spaceID?: ModelIDInput | null;
  isModified?: ModelBooleanInput | null;
  isImportedMatterport?: ModelBooleanInput | null;
  and?: Array<ModelPlanConditionInput | null> | null;
  or?: Array<ModelPlanConditionInput | null> | null;
  not?: ModelPlanConditionInput | null;
};

export type Plan = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: Zone | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: Space | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePlanInput = {
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
};

export type DeletePlanInput = {
  id: string;
};

export type CreateProfileInput = {
  id?: string | null;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
};

export enum ProfileStatus {
  WAITING_FOR_VALIDATION = "WAITING_FOR_VALIDATION",
  WAITING_FOR_ACTIVATION = "WAITING_FOR_ACTIVATION",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  BLOCKED = "BLOCKED"
}

export type ModelProfileConditionInput = {
  userID?: ModelStringInput | null;
  avatar?: ModelStringInput | null;
  token?: ModelStringInput | null;
  tokenExpiredAt?: ModelIntInput | null;
  status?: ModelProfileStatusInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  lastConnectedAt?: ModelIntInput | null;
  pseudo?: ModelStringInput | null;
  and?: Array<ModelProfileConditionInput | null> | null;
  or?: Array<ModelProfileConditionInput | null> | null;
  not?: ModelProfileConditionInput | null;
};

export type ModelProfileStatusInput = {
  eq?: ProfileStatus | null;
  ne?: ProfileStatus | null;
};

export type Profile = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateProfileInput = {
  id: string;
  userID?: string | null;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
};

export type DeleteProfileInput = {
  id: string;
};

export type CreateOrganisationInput = {
  id?: string | null;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
};

export type ModelOrganisationConditionInput = {
  name?: ModelStringInput | null;
  siret?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  postal?: ModelIntInput | null;
  logoUrl?: ModelStringInput | null;
  originDate?: ModelIntInput | null;
  deletedAt?: ModelIntInput | null;
  and?: Array<ModelOrganisationConditionInput | null> | null;
  or?: Array<ModelOrganisationConditionInput | null> | null;
  not?: ModelOrganisationConditionInput | null;
};

export type UpdateOrganisationInput = {
  id: string;
  name?: string | null;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
};

export type DeleteOrganisationInput = {
  id: string;
};

export type CreateMissionInput = {
  id?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  organisationID: string;
  userID: string;
  spaceID?: string | null;
  zoneID?: string | null;
  navigationID?: string | null;
  locale?: Locale | null;
};

export enum EmailStatus {
  CREATION_TO_DELIVER = "CREATION_TO_DELIVER",
  UPDATE_TO_DELIVER = "UPDATE_TO_DELIVER",
  CANCELLATION_TO_DELIVER = "CANCELLATION_TO_DELIVER",
  SENT = "SENT",
  SOFT_BOUNCE = "SOFT_BOUNCE",
  HARD_BOUNCE = "HARD_BOUNCE",
  REJECTED = "REJECTED"
}

export type ModelMissionConditionInput = {
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  emailStatus?: ModelEmailStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  groups?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  orderedOrganisationID?: ModelIDInput | null;
  organisationID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  navigationID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  and?: Array<ModelMissionConditionInput | null> | null;
  or?: Array<ModelMissionConditionInput | null> | null;
  not?: ModelMissionConditionInput | null;
};

export type ModelEmailStatusInput = {
  eq?: EmailStatus | null;
  ne?: EmailStatus | null;
};

export type ModelLocaleInput = {
  eq?: Locale | null;
  ne?: Locale | null;
};

export type Mission = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: Organisation | null;
  organisationID: string;
  organisation?: Organisation | null;
  userID: string;
  user?: Profile | null;
  spaceID?: string | null;
  space?: Space | null;
  zoneID?: string | null;
  zone?: Zone | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateMissionInput = {
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  organisationID?: string | null;
  userID?: string | null;
  spaceID?: string | null;
  zoneID?: string | null;
  navigationID?: string | null;
  locale?: Locale | null;
};

export type DeleteMissionInput = {
  id: string;
};

export type ModelRoomFilterInput = {
  id?: ModelIDInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  externalID?: ModelStringInput | null;
  internalRoomType?: ModelRoomTypeVRRoomInput | null;
  and?: Array<ModelRoomFilterInput | null> | null;
  or?: Array<ModelRoomFilterInput | null> | null;
  not?: ModelRoomFilterInput | null;
};

export type ModelRoomConnection = {
  __typename: "ModelRoomConnection";
  items: Array<Room | null>;
  nextToken?: string | null;
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC"
}

export type ModelIDKeyConditionInput = {
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
};

export type ModelRoomTypeFilterInput = {
  id?: ModelIDInput | null;
  externalID?: ModelIntInput | null;
  title?: ModelStringInput | null;
  description?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  nbPersonsMin?: ModelIntInput | null;
  nbPersonsMax?: ModelIntInput | null;
  and?: Array<ModelRoomTypeFilterInput | null> | null;
  or?: Array<ModelRoomTypeFilterInput | null> | null;
  not?: ModelRoomTypeFilterInput | null;
};

export type ModelRoomTypeConnection = {
  __typename: "ModelRoomTypeConnection";
  items: Array<RoomType | null>;
  nextToken?: string | null;
};

export type ModelReservationPostFilterInput = {
  id?: ModelIDInput | null;
  externalID?: ModelIntInput | null;
  roomThais?: ModelStringInput | null;
  stripeSessionID?: ModelStringInput | null;
  stripePaymentStatus?: ModelStripePaymentStatusInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelReservationPostFilterInput | null> | null;
  or?: Array<ModelReservationPostFilterInput | null> | null;
  not?: ModelReservationPostFilterInput | null;
};

export type ModelReservationPostConnection = {
  __typename: "ModelReservationPostConnection";
  items: Array<ReservationPost | null>;
  nextToken?: string | null;
};

export type ModelCaptureFilterInput = {
  id?: ModelIDInput | null;
  clientRef?: ModelStringInput | null;
  originCoordinate?: ModelStringInput | null;
  originAngle?: ModelStringInput | null;
  originZoom?: ModelStringInput | null;
  takenAt?: ModelIntInput | null;
  viewer?: ModelCaptureViewerInput | null;
  publishedAt?: ModelIntInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  spaceID?: ModelIDInput | null;
  and?: Array<ModelCaptureFilterInput | null> | null;
  or?: Array<ModelCaptureFilterInput | null> | null;
  not?: ModelCaptureFilterInput | null;
};

export type ModelCaptureConnection = {
  __typename: "ModelCaptureConnection";
  items: Array<Capture | null>;
  nextToken?: string | null;
};

export type ModelNodeFilterInput = {
  id?: ModelIDInput | null;
  model3D?: ModelStringInput | null;
  coordinate?: ModelStringInput | null;
  size?: ModelStringInput | null;
  scale?: ModelStringInput | null;
  version?: ModelIntInput | null;
  active?: ModelIntInput | null;
  order?: ModelIntInput | null;
  quality?: ModelNodeQualityInput | null;
  metadata?: ModelStringInput | null;
  captureID?: ModelIDInput | null;
  inventoryStatus?: ModelInventoryStatusInput | null;
  navigationForInventory?: ModelStringInput | null;
  and?: Array<ModelNodeFilterInput | null> | null;
  or?: Array<ModelNodeFilterInput | null> | null;
  not?: ModelNodeFilterInput | null;
};

export type ModelSpaceFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  addresses?: ModelStringInput | null;
  annexes?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  latitude?: ModelFloatInput | null;
  longitude?: ModelFloatInput | null;
  metadata?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  deletedAt?: ModelIntInput | null;
  organisationID?: ModelIDInput | null;
  guestLink?: ModelStringInput | null;
  description?: ModelStringInput | null;
  primaryColor?: ModelStringInput | null;
  connectedAccountStripeID?: ModelStringInput | null;
  stripeOnBoardingCompleted?: ModelBooleanInput | null;
  stripeChargesEnabled?: ModelBooleanInput | null;
  contactMail?: ModelStringInput | null;
  contactPhone?: ModelStringInput | null;
  contactSiteWeb?: ModelStringInput | null;
  pmsMetadata?: ModelStringInput | null;
  pmsName?: ModelStringInput | null;
  and?: Array<ModelSpaceFilterInput | null> | null;
  or?: Array<ModelSpaceFilterInput | null> | null;
  not?: ModelSpaceFilterInput | null;
};

export type ModelSpaceConnection = {
  __typename: "ModelSpaceConnection";
  items: Array<Space | null>;
  nextToken?: string | null;
};

export type ModelZoneFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  surface?: ModelIntInput | null;
  metadata?: ModelStringInput | null;
  parentID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  layerID?: ModelIDInput | null;
  isMuseumVisitZone?: ModelBooleanInput | null;
  sweepIDs?: ModelStringInput | null;
  nodeIDs?: ModelStringInput | null;
  isMultipleFloorZone?: ModelBooleanInput | null;
  and?: Array<ModelZoneFilterInput | null> | null;
  or?: Array<ModelZoneFilterInput | null> | null;
  not?: ModelZoneFilterInput | null;
};

export type ModelLayerFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  slug?: ModelStringInput | null;
  organisationID?: ModelIDInput | null;
  and?: Array<ModelLayerFilterInput | null> | null;
  or?: Array<ModelLayerFilterInput | null> | null;
  not?: ModelLayerFilterInput | null;
};

export type ModelLayerConnection = {
  __typename: "ModelLayerConnection";
  items: Array<Layer | null>;
  nextToken?: string | null;
};

export type ModelNavigationFilterInput = {
  id?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  position?: ModelStringInput | null;
  rotation?: ModelStringInput | null;
  radius?: ModelIntInput | null;
  url?: ModelStringInput | null;
  tags?: ModelStringInput | null;
  level?: ModelLevelStatusInput | null;
  nodeID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  positionOnPlan?: ModelStringInput | null;
  and?: Array<ModelNavigationFilterInput | null> | null;
  or?: Array<ModelNavigationFilterInput | null> | null;
  not?: ModelNavigationFilterInput | null;
};

export type ModelNavigationConnection = {
  __typename: "ModelNavigationConnection";
  items: Array<Navigation | null>;
  nextToken?: string | null;
};

export type ModelPOIFilterInput = {
  id?: ModelIDInput | null;
  coordinate?: ModelStringInput | null;
  specific?: ModelBooleanInput | null;
  private?: ModelBooleanInput | null;
  global?: ModelBooleanInput | null;
  type?: ModelPoiTypeInput | null;
  elementID?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  category?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  tagIcon?: ModelStringInput | null;
  tagDescription?: ModelStringInput | null;
  tagImageID?: ModelIDInput | null;
  matterportSweepID?: ModelStringInput | null;
  and?: Array<ModelPOIFilterInput | null> | null;
  or?: Array<ModelPOIFilterInput | null> | null;
  not?: ModelPOIFilterInput | null;
};

export type ModelPlanFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  annexe?: ModelStringInput | null;
  calibration?: ModelStringInput | null;
  zoneID?: ModelIDInput | null;
  isCurrentForZone?: ModelBooleanInput | null;
  spaceID?: ModelIDInput | null;
  isModified?: ModelBooleanInput | null;
  isImportedMatterport?: ModelBooleanInput | null;
  and?: Array<ModelPlanFilterInput | null> | null;
  or?: Array<ModelPlanFilterInput | null> | null;
  not?: ModelPlanFilterInput | null;
};

export type ModelPlanConnection = {
  __typename: "ModelPlanConnection";
  items: Array<Plan | null>;
  nextToken?: string | null;
};

export type ModelProfileFilterInput = {
  id?: ModelIDInput | null;
  userID?: ModelStringInput | null;
  avatar?: ModelStringInput | null;
  token?: ModelStringInput | null;
  tokenExpiredAt?: ModelIntInput | null;
  status?: ModelProfileStatusInput | null;
  metadata?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  lastConnectedAt?: ModelIntInput | null;
  pseudo?: ModelStringInput | null;
  and?: Array<ModelProfileFilterInput | null> | null;
  or?: Array<ModelProfileFilterInput | null> | null;
  not?: ModelProfileFilterInput | null;
};

export type ModelProfileConnection = {
  __typename: "ModelProfileConnection";
  items: Array<Profile | null>;
  nextToken?: string | null;
};

export type ModelOrganisationFilterInput = {
  id?: ModelIDInput | null;
  name?: ModelStringInput | null;
  siret?: ModelStringInput | null;
  address?: ModelStringInput | null;
  city?: ModelStringInput | null;
  postal?: ModelIntInput | null;
  logoUrl?: ModelStringInput | null;
  originDate?: ModelIntInput | null;
  deletedAt?: ModelIntInput | null;
  and?: Array<ModelOrganisationFilterInput | null> | null;
  or?: Array<ModelOrganisationFilterInput | null> | null;
  not?: ModelOrganisationFilterInput | null;
};

export type ModelOrganisationConnection = {
  __typename: "ModelOrganisationConnection";
  items: Array<Organisation | null>;
  nextToken?: string | null;
};

export type ModelMissionFilterInput = {
  id?: ModelIDInput | null;
  level?: ModelLevelStatusInput | null;
  role?: ModelRoleStatusInput | null;
  emailStatus?: ModelEmailStatusInput | null;
  description?: ModelStringInput | null;
  metadata?: ModelStringInput | null;
  groups?: ModelStringInput | null;
  deletedAt?: ModelIntInput | null;
  startDateTime?: ModelStringInput | null;
  endDateTime?: ModelStringInput | null;
  hashtags?: ModelStringInput | null;
  orderedOrganisationID?: ModelIDInput | null;
  organisationID?: ModelIDInput | null;
  userID?: ModelIDInput | null;
  spaceID?: ModelIDInput | null;
  zoneID?: ModelIDInput | null;
  navigationID?: ModelIDInput | null;
  locale?: ModelLocaleInput | null;
  and?: Array<ModelMissionFilterInput | null> | null;
  or?: Array<ModelMissionFilterInput | null> | null;
  not?: ModelMissionFilterInput | null;
};

export type ModelMissionConnection = {
  __typename: "ModelMissionConnection";
  items: Array<Mission | null>;
  nextToken?: string | null;
};

export type ModelSubscriptionRoomFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  externalID?: ModelSubscriptionStringInput | null;
  internalRoomType?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionRoomFilterInput | null> | null;
  or?: Array<ModelSubscriptionRoomFilterInput | null> | null;
};

export type ModelSubscriptionIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  in?: Array<string | null> | null;
  notIn?: Array<string | null> | null;
};

export type ModelSubscriptionRoomTypeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  externalID?: ModelSubscriptionIntInput | null;
  title?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  nbPersonsMin?: ModelSubscriptionIntInput | null;
  nbPersonsMax?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionRoomTypeFilterInput | null> | null;
  or?: Array<ModelSubscriptionRoomTypeFilterInput | null> | null;
};

export type ModelSubscriptionIntInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionReservationPostFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  externalID?: ModelSubscriptionIntInput | null;
  roomThais?: ModelSubscriptionStringInput | null;
  stripeSessionID?: ModelSubscriptionStringInput | null;
  stripePaymentStatus?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionReservationPostFilterInput | null> | null;
  or?: Array<ModelSubscriptionReservationPostFilterInput | null> | null;
};

export type ModelSubscriptionCaptureFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  clientRef?: ModelSubscriptionStringInput | null;
  originCoordinate?: ModelSubscriptionStringInput | null;
  originAngle?: ModelSubscriptionStringInput | null;
  originZoom?: ModelSubscriptionStringInput | null;
  takenAt?: ModelSubscriptionIntInput | null;
  viewer?: ModelSubscriptionStringInput | null;
  publishedAt?: ModelSubscriptionIntInput | null;
  surface?: ModelSubscriptionIntInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionCaptureFilterInput | null> | null;
  or?: Array<ModelSubscriptionCaptureFilterInput | null> | null;
};

export type ModelSubscriptionNodeFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  model3D?: ModelSubscriptionStringInput | null;
  coordinate?: ModelSubscriptionStringInput | null;
  size?: ModelSubscriptionStringInput | null;
  scale?: ModelSubscriptionStringInput | null;
  version?: ModelSubscriptionIntInput | null;
  active?: ModelSubscriptionIntInput | null;
  order?: ModelSubscriptionIntInput | null;
  quality?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  captureID?: ModelSubscriptionIDInput | null;
  inventoryStatus?: ModelSubscriptionStringInput | null;
  navigationForInventory?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionNodeFilterInput | null> | null;
  or?: Array<ModelSubscriptionNodeFilterInput | null> | null;
};

export type ModelSubscriptionSpaceFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  addresses?: ModelSubscriptionStringInput | null;
  annexes?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  latitude?: ModelSubscriptionFloatInput | null;
  longitude?: ModelSubscriptionFloatInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  level?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  guestLink?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  primaryColor?: ModelSubscriptionStringInput | null;
  connectedAccountStripeID?: ModelSubscriptionStringInput | null;
  stripeOnBoardingCompleted?: ModelSubscriptionBooleanInput | null;
  stripeChargesEnabled?: ModelSubscriptionBooleanInput | null;
  contactMail?: ModelSubscriptionStringInput | null;
  contactPhone?: ModelSubscriptionStringInput | null;
  contactSiteWeb?: ModelSubscriptionStringInput | null;
  pmsMetadata?: ModelSubscriptionStringInput | null;
  pmsName?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionSpaceFilterInput | null> | null;
  or?: Array<ModelSubscriptionSpaceFilterInput | null> | null;
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
  in?: Array<number | null> | null;
  notIn?: Array<number | null> | null;
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null;
  eq?: boolean | null;
};

export type ModelSubscriptionZoneFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  surface?: ModelSubscriptionIntInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  parentID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  layerID?: ModelSubscriptionIDInput | null;
  isMuseumVisitZone?: ModelSubscriptionBooleanInput | null;
  sweepIDs?: ModelSubscriptionStringInput | null;
  nodeIDs?: ModelSubscriptionStringInput | null;
  isMultipleFloorZone?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionZoneFilterInput | null> | null;
  or?: Array<ModelSubscriptionZoneFilterInput | null> | null;
};

export type ModelSubscriptionLayerFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  slug?: ModelSubscriptionStringInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  and?: Array<ModelSubscriptionLayerFilterInput | null> | null;
  or?: Array<ModelSubscriptionLayerFilterInput | null> | null;
};

export type ModelSubscriptionNavigationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  matterportSweepID?: ModelSubscriptionStringInput | null;
  position?: ModelSubscriptionStringInput | null;
  rotation?: ModelSubscriptionStringInput | null;
  radius?: ModelSubscriptionIntInput | null;
  url?: ModelSubscriptionStringInput | null;
  tags?: ModelSubscriptionStringInput | null;
  level?: ModelSubscriptionStringInput | null;
  nodeID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  positionOnPlan?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionNavigationFilterInput | null> | null;
  or?: Array<ModelSubscriptionNavigationFilterInput | null> | null;
};

export type ModelSubscriptionPOIFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  coordinate?: ModelSubscriptionStringInput | null;
  specific?: ModelSubscriptionBooleanInput | null;
  private?: ModelSubscriptionBooleanInput | null;
  global?: ModelSubscriptionBooleanInput | null;
  type?: ModelSubscriptionStringInput | null;
  elementID?: ModelSubscriptionIDInput | null;
  level?: ModelSubscriptionStringInput | null;
  role?: ModelSubscriptionStringInput | null;
  category?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  tagIcon?: ModelSubscriptionStringInput | null;
  tagDescription?: ModelSubscriptionStringInput | null;
  tagImageID?: ModelSubscriptionIDInput | null;
  matterportSweepID?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionPOIFilterInput | null> | null;
  or?: Array<ModelSubscriptionPOIFilterInput | null> | null;
};

export type ModelSubscriptionPlanFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  annexe?: ModelSubscriptionStringInput | null;
  calibration?: ModelSubscriptionStringInput | null;
  zoneID?: ModelSubscriptionIDInput | null;
  isCurrentForZone?: ModelSubscriptionBooleanInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  isModified?: ModelSubscriptionBooleanInput | null;
  isImportedMatterport?: ModelSubscriptionBooleanInput | null;
  and?: Array<ModelSubscriptionPlanFilterInput | null> | null;
  or?: Array<ModelSubscriptionPlanFilterInput | null> | null;
};

export type ModelSubscriptionProfileFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  userID?: ModelSubscriptionStringInput | null;
  avatar?: ModelSubscriptionStringInput | null;
  token?: ModelSubscriptionStringInput | null;
  tokenExpiredAt?: ModelSubscriptionIntInput | null;
  status?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  lastConnectedAt?: ModelSubscriptionIntInput | null;
  pseudo?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionProfileFilterInput | null> | null;
  or?: Array<ModelSubscriptionProfileFilterInput | null> | null;
};

export type ModelSubscriptionOrganisationFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  name?: ModelSubscriptionStringInput | null;
  siret?: ModelSubscriptionStringInput | null;
  address?: ModelSubscriptionStringInput | null;
  city?: ModelSubscriptionStringInput | null;
  postal?: ModelSubscriptionIntInput | null;
  logoUrl?: ModelSubscriptionStringInput | null;
  originDate?: ModelSubscriptionIntInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  and?: Array<ModelSubscriptionOrganisationFilterInput | null> | null;
  or?: Array<ModelSubscriptionOrganisationFilterInput | null> | null;
};

export type ModelSubscriptionMissionFilterInput = {
  id?: ModelSubscriptionIDInput | null;
  level?: ModelSubscriptionStringInput | null;
  role?: ModelSubscriptionStringInput | null;
  emailStatus?: ModelSubscriptionStringInput | null;
  description?: ModelSubscriptionStringInput | null;
  metadata?: ModelSubscriptionStringInput | null;
  groups?: ModelSubscriptionStringInput | null;
  deletedAt?: ModelSubscriptionIntInput | null;
  startDateTime?: ModelSubscriptionStringInput | null;
  endDateTime?: ModelSubscriptionStringInput | null;
  hashtags?: ModelSubscriptionStringInput | null;
  orderedOrganisationID?: ModelSubscriptionIDInput | null;
  organisationID?: ModelSubscriptionIDInput | null;
  userID?: ModelSubscriptionIDInput | null;
  spaceID?: ModelSubscriptionIDInput | null;
  zoneID?: ModelSubscriptionIDInput | null;
  navigationID?: ModelSubscriptionIDInput | null;
  locale?: ModelSubscriptionStringInput | null;
  and?: Array<ModelSubscriptionMissionFilterInput | null> | null;
  or?: Array<ModelSubscriptionMissionFilterInput | null> | null;
};

export type CreateRoomMutation = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateRoomMutation = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteRoomMutation = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateRoomTypeMutation = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateRoomTypeMutation = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteRoomTypeMutation = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateReservationPostMutation = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateReservationPostMutation = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteReservationPostMutation = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteCaptureMutation = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateNodeMutation = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateNodeMutation = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteNodeMutation = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteSpaceMutation = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteZoneMutation = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateLayerMutation = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateLayerMutation = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteLayerMutation = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteNavigationMutation = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePOIMutation = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePOIMutation = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeletePOIMutation = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreatePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdatePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type DeletePlanMutation = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateProfileMutation = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateProfileMutation = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteProfileMutation = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteOrganisationMutation = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateMissionMutation = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type UpdateMissionMutation = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type DeleteMissionMutation = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type GetRoomQuery = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type ListRoomsQuery = {
  __typename: "ModelRoomConnection";
  items: Array<{
    __typename: "Room";
    id: string;
    title?: string | null;
    description?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    externalID?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id: string;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    internalRoomType?: RoomTypeVRRoom | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type RoomsBySpaceQuery = {
  __typename: "ModelRoomConnection";
  items: Array<{
    __typename: "Room";
    id: string;
    title?: string | null;
    description?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    externalID?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id: string;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    internalRoomType?: RoomTypeVRRoom | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type RoomsByExternalIDBySpaceQuery = {
  __typename: "ModelRoomConnection";
  items: Array<{
    __typename: "Room";
    id: string;
    title?: string | null;
    description?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    externalID?: string | null;
    pois?: {
      __typename: "ModelPOIConnection";
      items: Array<{
        __typename: "POI";
        id: string;
        coordinate?: string | null;
        specific?: boolean | null;
        private?: boolean | null;
        global?: boolean | null;
        type?: PoiType | null;
        elementID?: string | null;
        level?: LevelStatus | null;
        role?: RoleStatus | null;
        category?: Array<string | null> | null;
        metadata?: string | null;
        tagIcon?: string | null;
        tagDescription?: string | null;
        tagImageID?: string | null;
        matterportSweepID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    internalRoomType?: RoomTypeVRRoom | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetRoomTypeQuery = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ListRoomTypesQuery = {
  __typename: "ModelRoomTypeConnection";
  items: Array<{
    __typename: "RoomType";
    id: string;
    externalID?: number | null;
    title?: string | null;
    description?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    nbPersonsMin?: number | null;
    nbPersonsMax?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type RoomTypesBySpaceQuery = {
  __typename: "ModelRoomTypeConnection";
  items: Array<{
    __typename: "RoomType";
    id: string;
    externalID?: number | null;
    title?: string | null;
    description?: string | null;
    spaceID: string;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    nbPersonsMin?: number | null;
    nbPersonsMax?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetReservationPostQuery = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListReservationPostsQuery = {
  __typename: "ModelReservationPostConnection";
  items: Array<{
    __typename: "ReservationPost";
    id?: string | null;
    externalID?: number | null;
    reservationThais?: {
      __typename: "ReservationThais";
      checkin?: string | null;
      checkout?: string | null;
      comment?: string | null;
      customer_civility_id?: number | null;
      customer_firstname?: string | null;
      customer_lastname?: string | null;
      customer_email?: string | null;
      customer_phone?: string | null;
      customer_mobile?: string | null;
      customer_zipcode?: string | null;
      customer_city?: string | null;
      customer_address?: string | null;
      customer_country?: string | null;
      channel_name?: string | null;
      payment_type?: string | null;
      payment_amount?: number | null;
      insurance_amount?: number | null;
      booking_rooms?: Array<{
        __typename: "BookingRoom";
        room_id?: number | null;
        room_type_id?: number | null;
        rate_id?: number | null;
        price?: number | null;
      } | null> | null;
    } | null;
    roomThais?: string | null;
    stripeSessionID?: string | null;
    stripePaymentStatus?: StripePaymentStatus | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ReservationsByStripeSessionQuery = {
  __typename: "ModelReservationPostConnection";
  items: Array<{
    __typename: "ReservationPost";
    id?: string | null;
    externalID?: number | null;
    reservationThais?: {
      __typename: "ReservationThais";
      checkin?: string | null;
      checkout?: string | null;
      comment?: string | null;
      customer_civility_id?: number | null;
      customer_firstname?: string | null;
      customer_lastname?: string | null;
      customer_email?: string | null;
      customer_phone?: string | null;
      customer_mobile?: string | null;
      customer_zipcode?: string | null;
      customer_city?: string | null;
      customer_address?: string | null;
      customer_country?: string | null;
      channel_name?: string | null;
      payment_type?: string | null;
      payment_amount?: number | null;
      insurance_amount?: number | null;
      booking_rooms?: Array<{
        __typename: "BookingRoom";
        room_id?: number | null;
        room_type_id?: number | null;
        rate_id?: number | null;
        price?: number | null;
      } | null> | null;
    } | null;
    roomThais?: string | null;
    stripeSessionID?: string | null;
    stripePaymentStatus?: StripePaymentStatus | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetCaptureQuery = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListCapturesQuery = {
  __typename: "ModelCaptureConnection";
  items: Array<{
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type CapturesBySpaceQuery = {
  __typename: "ModelCaptureConnection";
  items: Array<{
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetNodeQuery = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListNodesQuery = {
  __typename: "ModelNodeConnection";
  items: Array<{
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NodesByCaptureQuery = {
  __typename: "ModelNodeConnection";
  items: Array<{
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetSpaceQuery = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListSpacesQuery = {
  __typename: "ModelSpaceConnection";
  items: Array<{
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type SpacesByOrganisationQuery = {
  __typename: "ModelSpaceConnection";
  items: Array<{
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type SpacesByStripeAccountQuery = {
  __typename: "ModelSpaceConnection";
  items: Array<{
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetZoneQuery = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ListZonesQuery = {
  __typename: "ModelZoneConnection";
  items: Array<{
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ZonesBySpaceQuery = {
  __typename: "ModelZoneConnection";
  items: Array<{
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetLayerQuery = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type ListLayersQuery = {
  __typename: "ModelLayerConnection";
  items: Array<{
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type LayersByOrganisationQuery = {
  __typename: "ModelLayerConnection";
  items: Array<{
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetNavigationQuery = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type ListNavigationsQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NavigationsByMatterportIDBySpaceQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type NavigationsByNodeQuery = {
  __typename: "ModelNavigationConnection";
  items: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetPOIQuery = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListPOISQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id: string;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PoisByTypeQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id: string;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PoisByElementQuery = {
  __typename: "ModelPOIConnection";
  items: Array<{
    __typename: "POI";
    id: string;
    coordinate?: string | null;
    specific?: boolean | null;
    private?: boolean | null;
    global?: boolean | null;
    type?: PoiType | null;
    elementID?: string | null;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    category?: Array<string | null> | null;
    metadata?: string | null;
    tagIcon?: string | null;
    tagDescription?: string | null;
    tagImageID?: string | null;
    matterportSweepID?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetPlanQuery = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type ListPlansQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PlansByZoneQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type PlansBySpaceQuery = {
  __typename: "ModelPlanConnection";
  items: Array<{
    __typename: "Plan";
    id: string;
    name?: string | null;
    annexe?: string | null;
    calibration?: string | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isCurrentForZone?: boolean | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isModified?: boolean | null;
    isImportedMatterport?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetProfileQuery = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type ListProfilesQuery = {
  __typename: "ModelProfileConnection";
  items: Array<{
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type ProfilesByUserIDQuery = {
  __typename: "ModelProfileConnection";
  items: Array<{
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetOrganisationQuery = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type ListOrganisationsQuery = {
  __typename: "ModelOrganisationConnection";
  items: Array<{
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type GetMissionQuery = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type ListMissionsQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByOrderedOrganisationBySpaceQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByOrganisationQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByUserQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsBySpaceQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type MissionsByZoneQuery = {
  __typename: "ModelMissionConnection";
  items: Array<{
    __typename: "Mission";
    id: string;
    level?: LevelStatus | null;
    role?: RoleStatus | null;
    emailStatus?: EmailStatus | null;
    description?: string | null;
    metadata?: string | null;
    groups?: Array<string | null> | null;
    deletedAt?: number | null;
    startDateTime?: string | null;
    endDateTime?: string | null;
    hashtags?: Array<string | null> | null;
    orderedOrganisationID?: string | null;
    orderedOrganisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    organisationID: string;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    userID: string;
    user?: {
      __typename: "Profile";
      id: string;
      userID: string;
      avatar?: string | null;
      token?: string | null;
      tokenExpiredAt?: number | null;
      status?: ProfileStatus | null;
      metadata?: string | null;
      deletedAt?: number | null;
      lastConnectedAt?: number | null;
      pseudo?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zoneID?: string | null;
    zone?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    navigationID?: string | null;
    locale?: Locale | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
  nextToken?: string | null;
};

export type OnCreateRoomSubscription = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateRoomSubscription = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteRoomSubscription = {
  __typename: "Room";
  id: string;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  externalID?: string | null;
  pois?: {
    __typename: "ModelPOIConnection";
    items: Array<{
      __typename: "POI";
      id: string;
      coordinate?: string | null;
      specific?: boolean | null;
      private?: boolean | null;
      global?: boolean | null;
      type?: PoiType | null;
      elementID?: string | null;
      level?: LevelStatus | null;
      role?: RoleStatus | null;
      category?: Array<string | null> | null;
      metadata?: string | null;
      tagIcon?: string | null;
      tagDescription?: string | null;
      tagImageID?: string | null;
      matterportSweepID?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  internalRoomType?: RoomTypeVRRoom | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateRoomTypeSubscription = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateRoomTypeSubscription = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteRoomTypeSubscription = {
  __typename: "RoomType";
  id: string;
  externalID?: number | null;
  title?: string | null;
  description?: string | null;
  spaceID: string;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  nbPersonsMin?: number | null;
  nbPersonsMax?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateReservationPostSubscription = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateReservationPostSubscription = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteReservationPostSubscription = {
  __typename: "ReservationPost";
  id?: string | null;
  externalID?: number | null;
  reservationThais?: {
    __typename: "ReservationThais";
    checkin?: string | null;
    checkout?: string | null;
    comment?: string | null;
    customer_civility_id?: number | null;
    customer_firstname?: string | null;
    customer_lastname?: string | null;
    customer_email?: string | null;
    customer_phone?: string | null;
    customer_mobile?: string | null;
    customer_zipcode?: string | null;
    customer_city?: string | null;
    customer_address?: string | null;
    customer_country?: string | null;
    channel_name?: string | null;
    payment_type?: string | null;
    payment_amount?: number | null;
    insurance_amount?: number | null;
    booking_rooms?: Array<{
      __typename: "BookingRoom";
      room_id?: number | null;
      room_type_id?: number | null;
      rate_id?: number | null;
      price?: number | null;
      nb_persons?: {
        __typename: "NumberPersons";
        adults?: number | null;
        children?: number | null;
      } | null;
      extras?: Array<{
        __typename: "ExtraReservation";
        article_id?: number | null;
        label?: string | null;
        quantity?: number | null;
        unit_price_incl?: number | null;
        date?: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  roomThais?: string | null;
  stripeSessionID?: string | null;
  stripePaymentStatus?: StripePaymentStatus | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteCaptureSubscription = {
  __typename: "Capture";
  id: string;
  clientRef?: string | null;
  originCoordinate?: string | null;
  originAngle?: string | null;
  originZoom?: string | null;
  takenAt?: number | null;
  viewer?: CaptureViewer | null;
  publishedAt?: number | null;
  surface?: number | null;
  metadata?: string | null;
  spaceID?: string | null;
  nodes?: {
    __typename: "ModelNodeConnection";
    items: Array<{
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateNodeSubscription = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateNodeSubscription = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteNodeSubscription = {
  __typename: "Node";
  id: string;
  model3D?: string | null;
  coordinate?: string | null;
  size?: string | null;
  scale?: string | null;
  version?: number | null;
  active?: number | null;
  order?: number | null;
  quality?: NodeQuality | null;
  metadata?: string | null;
  captureID?: string | null;
  capture?: {
    __typename: "Capture";
    id: string;
    clientRef?: string | null;
    originCoordinate?: string | null;
    originAngle?: string | null;
    originZoom?: string | null;
    takenAt?: number | null;
    viewer?: CaptureViewer | null;
    publishedAt?: number | null;
    surface?: number | null;
    metadata?: string | null;
    spaceID?: string | null;
    nodes?: {
      __typename: "ModelNodeConnection";
      items: Array<{
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  inventoryStatus?: InventoryStatus | null;
  navigationForInventory?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteSpaceSubscription = {
  __typename: "Space";
  id: string;
  name: string;
  addresses?: string | null;
  annexes?: string | null;
  tags?: Array<string | null> | null;
  latitude?: number | null;
  longitude?: number | null;
  metadata?: string | null;
  level?: LevelStatus | null;
  deletedAt?: number | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zones?: {
    __typename: "ModelZoneConnection";
    items: Array<{
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null>;
    nextToken?: string | null;
  } | null;
  guestLink?: string | null;
  description?: string | null;
  primaryColor?: string | null;
  connectedAccountStripeID?: string | null;
  stripeOnBoardingCompleted?: boolean | null;
  stripeChargesEnabled?: boolean | null;
  contactMail?: string | null;
  contactPhone?: string | null;
  contactSiteWeb?: string | null;
  pmsMetadata?: string | null;
  pmsName?: string | null;
  urlCustomReservationForm?: Array<{
    __typename: "DataPerLocale";
    locale?: Locale | null;
    data?: string | null;
  } | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteZoneSubscription = {
  __typename: "Zone";
  id: string;
  name: string;
  tags?: Array<string | null> | null;
  surface?: number | null;
  metadata?: string | null;
  parentID?: string | null;
  parent?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  layerID?: string | null;
  layer?: {
    __typename: "Layer";
    id: string;
    name: string;
    slug?: string | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isMuseumVisitZone?: boolean | null;
  sweepIDs?: Array<string | null> | null;
  nodeIDs?: Array<string | null> | null;
  isMultipleFloorZone?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateLayerSubscription = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateLayerSubscription = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteLayerSubscription = {
  __typename: "Layer";
  id: string;
  name: string;
  slug?: string | null;
  organisationID?: string | null;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteNavigationSubscription = {
  __typename: "Navigation";
  id: string;
  matterportSweepID?: string | null;
  siblings?: Array<{
    __typename: "Navigation";
    id: string;
    matterportSweepID?: string | null;
    siblings?: Array<{
      __typename: "Navigation";
      id: string;
      matterportSweepID?: string | null;
      siblings?: Array<{
        __typename: "Navigation";
        id: string;
        matterportSweepID?: string | null;
        position?: string | null;
        rotation?: string | null;
        radius?: number | null;
        url?: string | null;
        tags?: Array<string | null> | null;
        level?: LevelStatus | null;
        nodeID?: string | null;
        spaceID?: string | null;
        positionOnPlan?: Array<string | null> | null;
        createdAt: string;
        updatedAt: string;
      } | null> | null;
      position?: string | null;
      rotation?: string | null;
      radius?: number | null;
      url?: string | null;
      tags?: Array<string | null> | null;
      level?: LevelStatus | null;
      nodeID?: string | null;
      node?: {
        __typename: "Node";
        id: string;
        model3D?: string | null;
        coordinate?: string | null;
        size?: string | null;
        scale?: string | null;
        version?: number | null;
        active?: number | null;
        order?: number | null;
        quality?: NodeQuality | null;
        metadata?: string | null;
        captureID?: string | null;
        inventoryStatus?: InventoryStatus | null;
        navigationForInventory?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      positionOnPlan?: Array<string | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null> | null;
    position?: string | null;
    rotation?: string | null;
    radius?: number | null;
    url?: string | null;
    tags?: Array<string | null> | null;
    level?: LevelStatus | null;
    nodeID?: string | null;
    node?: {
      __typename: "Node";
      id: string;
      model3D?: string | null;
      coordinate?: string | null;
      size?: string | null;
      scale?: string | null;
      version?: number | null;
      active?: number | null;
      order?: number | null;
      quality?: NodeQuality | null;
      metadata?: string | null;
      captureID?: string | null;
      capture?: {
        __typename: "Capture";
        id: string;
        clientRef?: string | null;
        originCoordinate?: string | null;
        originAngle?: string | null;
        originZoom?: string | null;
        takenAt?: number | null;
        viewer?: CaptureViewer | null;
        publishedAt?: number | null;
        surface?: number | null;
        metadata?: string | null;
        spaceID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      inventoryStatus?: InventoryStatus | null;
      navigationForInventory?: string | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    positionOnPlan?: Array<string | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null> | null;
  position?: string | null;
  rotation?: string | null;
  radius?: number | null;
  url?: string | null;
  tags?: Array<string | null> | null;
  level?: LevelStatus | null;
  nodeID?: string | null;
  node?: {
    __typename: "Node";
    id: string;
    model3D?: string | null;
    coordinate?: string | null;
    size?: string | null;
    scale?: string | null;
    version?: number | null;
    active?: number | null;
    order?: number | null;
    quality?: NodeQuality | null;
    metadata?: string | null;
    captureID?: string | null;
    capture?: {
      __typename: "Capture";
      id: string;
      clientRef?: string | null;
      originCoordinate?: string | null;
      originAngle?: string | null;
      originZoom?: string | null;
      takenAt?: number | null;
      viewer?: CaptureViewer | null;
      publishedAt?: number | null;
      surface?: number | null;
      metadata?: string | null;
      spaceID?: string | null;
      nodes?: {
        __typename: "ModelNodeConnection";
        nextToken?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    inventoryStatus?: InventoryStatus | null;
    navigationForInventory?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  positionOnPlan?: Array<string | null> | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreatePOISubscription = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdatePOISubscription = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeletePOISubscription = {
  __typename: "POI";
  id: string;
  coordinate?: string | null;
  specific?: boolean | null;
  private?: boolean | null;
  global?: boolean | null;
  type?: PoiType | null;
  elementID?: string | null;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  category?: Array<string | null> | null;
  metadata?: string | null;
  tagIcon?: string | null;
  tagDescription?: string | null;
  tagImageID?: string | null;
  matterportSweepID?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreatePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdatePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeletePlanSubscription = {
  __typename: "Plan";
  id: string;
  name?: string | null;
  annexe?: string | null;
  calibration?: string | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isCurrentForZone?: boolean | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  isModified?: boolean | null;
  isImportedMatterport?: boolean | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateProfileSubscription = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateProfileSubscription = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteProfileSubscription = {
  __typename: "Profile";
  id: string;
  userID: string;
  avatar?: string | null;
  token?: string | null;
  tokenExpiredAt?: number | null;
  status?: ProfileStatus | null;
  metadata?: string | null;
  deletedAt?: number | null;
  lastConnectedAt?: number | null;
  pseudo?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteOrganisationSubscription = {
  __typename: "Organisation";
  id: string;
  name: string;
  siret?: string | null;
  address?: string | null;
  city?: string | null;
  postal?: number | null;
  logoUrl?: string | null;
  originDate?: number | null;
  deletedAt?: number | null;
  createdAt: string;
  updatedAt: string;
};

export type OnCreateMissionSubscription = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type OnUpdateMissionSubscription = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

export type OnDeleteMissionSubscription = {
  __typename: "Mission";
  id: string;
  level?: LevelStatus | null;
  role?: RoleStatus | null;
  emailStatus?: EmailStatus | null;
  description?: string | null;
  metadata?: string | null;
  groups?: Array<string | null> | null;
  deletedAt?: number | null;
  startDateTime?: string | null;
  endDateTime?: string | null;
  hashtags?: Array<string | null> | null;
  orderedOrganisationID?: string | null;
  orderedOrganisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  organisationID: string;
  organisation?: {
    __typename: "Organisation";
    id: string;
    name: string;
    siret?: string | null;
    address?: string | null;
    city?: string | null;
    postal?: number | null;
    logoUrl?: string | null;
    originDate?: number | null;
    deletedAt?: number | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  userID: string;
  user?: {
    __typename: "Profile";
    id: string;
    userID: string;
    avatar?: string | null;
    token?: string | null;
    tokenExpiredAt?: number | null;
    status?: ProfileStatus | null;
    metadata?: string | null;
    deletedAt?: number | null;
    lastConnectedAt?: number | null;
    pseudo?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  spaceID?: string | null;
  space?: {
    __typename: "Space";
    id: string;
    name: string;
    addresses?: string | null;
    annexes?: string | null;
    tags?: Array<string | null> | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
    level?: LevelStatus | null;
    deletedAt?: number | null;
    organisationID?: string | null;
    organisation?: {
      __typename: "Organisation";
      id: string;
      name: string;
      siret?: string | null;
      address?: string | null;
      city?: string | null;
      postal?: number | null;
      logoUrl?: string | null;
      originDate?: number | null;
      deletedAt?: number | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    zones?: {
      __typename: "ModelZoneConnection";
      items: Array<{
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null>;
      nextToken?: string | null;
    } | null;
    guestLink?: string | null;
    description?: string | null;
    primaryColor?: string | null;
    connectedAccountStripeID?: string | null;
    stripeOnBoardingCompleted?: boolean | null;
    stripeChargesEnabled?: boolean | null;
    contactMail?: string | null;
    contactPhone?: string | null;
    contactSiteWeb?: string | null;
    pmsMetadata?: string | null;
    pmsName?: string | null;
    urlCustomReservationForm?: Array<{
      __typename: "DataPerLocale";
      locale?: Locale | null;
      data?: string | null;
    } | null> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  zoneID?: string | null;
  zone?: {
    __typename: "Zone";
    id: string;
    name: string;
    tags?: Array<string | null> | null;
    surface?: number | null;
    metadata?: string | null;
    parentID?: string | null;
    parent?: {
      __typename: "Zone";
      id: string;
      name: string;
      tags?: Array<string | null> | null;
      surface?: number | null;
      metadata?: string | null;
      parentID?: string | null;
      parent?: {
        __typename: "Zone";
        id: string;
        name: string;
        tags?: Array<string | null> | null;
        surface?: number | null;
        metadata?: string | null;
        parentID?: string | null;
        spaceID?: string | null;
        layerID?: string | null;
        isMuseumVisitZone?: boolean | null;
        sweepIDs?: Array<string | null> | null;
        nodeIDs?: Array<string | null> | null;
        isMultipleFloorZone?: boolean | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      spaceID?: string | null;
      space?: {
        __typename: "Space";
        id: string;
        name: string;
        addresses?: string | null;
        annexes?: string | null;
        tags?: Array<string | null> | null;
        latitude?: number | null;
        longitude?: number | null;
        metadata?: string | null;
        level?: LevelStatus | null;
        deletedAt?: number | null;
        organisationID?: string | null;
        guestLink?: string | null;
        description?: string | null;
        primaryColor?: string | null;
        connectedAccountStripeID?: string | null;
        stripeOnBoardingCompleted?: boolean | null;
        stripeChargesEnabled?: boolean | null;
        contactMail?: string | null;
        contactPhone?: string | null;
        contactSiteWeb?: string | null;
        pmsMetadata?: string | null;
        pmsName?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      layerID?: string | null;
      layer?: {
        __typename: "Layer";
        id: string;
        name: string;
        slug?: string | null;
        organisationID?: string | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      isMuseumVisitZone?: boolean | null;
      sweepIDs?: Array<string | null> | null;
      nodeIDs?: Array<string | null> | null;
      isMultipleFloorZone?: boolean | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    spaceID?: string | null;
    space?: {
      __typename: "Space";
      id: string;
      name: string;
      addresses?: string | null;
      annexes?: string | null;
      tags?: Array<string | null> | null;
      latitude?: number | null;
      longitude?: number | null;
      metadata?: string | null;
      level?: LevelStatus | null;
      deletedAt?: number | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      zones?: {
        __typename: "ModelZoneConnection";
        nextToken?: string | null;
      } | null;
      guestLink?: string | null;
      description?: string | null;
      primaryColor?: string | null;
      connectedAccountStripeID?: string | null;
      stripeOnBoardingCompleted?: boolean | null;
      stripeChargesEnabled?: boolean | null;
      contactMail?: string | null;
      contactPhone?: string | null;
      contactSiteWeb?: string | null;
      pmsMetadata?: string | null;
      pmsName?: string | null;
      urlCustomReservationForm?: Array<{
        __typename: "DataPerLocale";
        locale?: Locale | null;
        data?: string | null;
      } | null> | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    layerID?: string | null;
    layer?: {
      __typename: "Layer";
      id: string;
      name: string;
      slug?: string | null;
      organisationID?: string | null;
      organisation?: {
        __typename: "Organisation";
        id: string;
        name: string;
        siret?: string | null;
        address?: string | null;
        city?: string | null;
        postal?: number | null;
        logoUrl?: string | null;
        originDate?: number | null;
        deletedAt?: number | null;
        createdAt: string;
        updatedAt: string;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    isMuseumVisitZone?: boolean | null;
    sweepIDs?: Array<string | null> | null;
    nodeIDs?: Array<string | null> | null;
    isMultipleFloorZone?: boolean | null;
    createdAt: string;
    updatedAt: string;
  } | null;
  navigationID?: string | null;
  locale?: Locale | null;
  createdAt: string;
  updatedAt: string;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async CreateRoom(
    input: CreateRoomInput,
    condition?: ModelRoomConditionInput
  ): Promise<CreateRoomMutation> {
    const statement = `mutation CreateRoom($input: CreateRoomInput!, $condition: ModelRoomConditionInput) {
        createRoom(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateRoomMutation>response.data.createRoom;
  }
  async UpdateRoom(
    input: UpdateRoomInput,
    condition?: ModelRoomConditionInput
  ): Promise<UpdateRoomMutation> {
    const statement = `mutation UpdateRoom($input: UpdateRoomInput!, $condition: ModelRoomConditionInput) {
        updateRoom(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateRoomMutation>response.data.updateRoom;
  }
  async DeleteRoom(
    input: DeleteRoomInput,
    condition?: ModelRoomConditionInput
  ): Promise<DeleteRoomMutation> {
    const statement = `mutation DeleteRoom($input: DeleteRoomInput!, $condition: ModelRoomConditionInput) {
        deleteRoom(input: $input, condition: $condition) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteRoomMutation>response.data.deleteRoom;
  }
  async CreateRoomType(
    input: CreateRoomTypeInput,
    condition?: ModelRoomTypeConditionInput
  ): Promise<CreateRoomTypeMutation> {
    const statement = `mutation CreateRoomType($input: CreateRoomTypeInput!, $condition: ModelRoomTypeConditionInput) {
        createRoomType(input: $input, condition: $condition) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateRoomTypeMutation>response.data.createRoomType;
  }
  async UpdateRoomType(
    input: UpdateRoomTypeInput,
    condition?: ModelRoomTypeConditionInput
  ): Promise<UpdateRoomTypeMutation> {
    const statement = `mutation UpdateRoomType($input: UpdateRoomTypeInput!, $condition: ModelRoomTypeConditionInput) {
        updateRoomType(input: $input, condition: $condition) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateRoomTypeMutation>response.data.updateRoomType;
  }
  async DeleteRoomType(
    input: DeleteRoomTypeInput,
    condition?: ModelRoomTypeConditionInput
  ): Promise<DeleteRoomTypeMutation> {
    const statement = `mutation DeleteRoomType($input: DeleteRoomTypeInput!, $condition: ModelRoomTypeConditionInput) {
        deleteRoomType(input: $input, condition: $condition) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteRoomTypeMutation>response.data.deleteRoomType;
  }
  async CreateReservationPost(
    input: CreateReservationPostInput,
    condition?: ModelReservationPostConditionInput
  ): Promise<CreateReservationPostMutation> {
    const statement = `mutation CreateReservationPost($input: CreateReservationPostInput!, $condition: ModelReservationPostConditionInput) {
        createReservationPost(input: $input, condition: $condition) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateReservationPostMutation>response.data.createReservationPost;
  }
  async UpdateReservationPost(
    input: UpdateReservationPostInput,
    condition?: ModelReservationPostConditionInput
  ): Promise<UpdateReservationPostMutation> {
    const statement = `mutation UpdateReservationPost($input: UpdateReservationPostInput!, $condition: ModelReservationPostConditionInput) {
        updateReservationPost(input: $input, condition: $condition) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateReservationPostMutation>response.data.updateReservationPost;
  }
  async DeleteReservationPost(
    input: DeleteReservationPostInput,
    condition?: ModelReservationPostConditionInput
  ): Promise<DeleteReservationPostMutation> {
    const statement = `mutation DeleteReservationPost($input: DeleteReservationPostInput!, $condition: ModelReservationPostConditionInput) {
        deleteReservationPost(input: $input, condition: $condition) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteReservationPostMutation>response.data.deleteReservationPost;
  }
  async CreateCapture(
    input: CreateCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<CreateCaptureMutation> {
    const statement = `mutation CreateCapture($input: CreateCaptureInput!, $condition: ModelCaptureConditionInput) {
        createCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateCaptureMutation>response.data.createCapture;
  }
  async UpdateCapture(
    input: UpdateCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<UpdateCaptureMutation> {
    const statement = `mutation UpdateCapture($input: UpdateCaptureInput!, $condition: ModelCaptureConditionInput) {
        updateCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateCaptureMutation>response.data.updateCapture;
  }
  async DeleteCapture(
    input: DeleteCaptureInput,
    condition?: ModelCaptureConditionInput
  ): Promise<DeleteCaptureMutation> {
    const statement = `mutation DeleteCapture($input: DeleteCaptureInput!, $condition: ModelCaptureConditionInput) {
        deleteCapture(input: $input, condition: $condition) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteCaptureMutation>response.data.deleteCapture;
  }
  async CreateNode(
    input: CreateNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<CreateNodeMutation> {
    const statement = `mutation CreateNode($input: CreateNodeInput!, $condition: ModelNodeConditionInput) {
        createNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNodeMutation>response.data.createNode;
  }
  async UpdateNode(
    input: UpdateNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<UpdateNodeMutation> {
    const statement = `mutation UpdateNode($input: UpdateNodeInput!, $condition: ModelNodeConditionInput) {
        updateNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNodeMutation>response.data.updateNode;
  }
  async DeleteNode(
    input: DeleteNodeInput,
    condition?: ModelNodeConditionInput
  ): Promise<DeleteNodeMutation> {
    const statement = `mutation DeleteNode($input: DeleteNodeInput!, $condition: ModelNodeConditionInput) {
        deleteNode(input: $input, condition: $condition) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNodeMutation>response.data.deleteNode;
  }
  async CreateSpace(
    input: CreateSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<CreateSpaceMutation> {
    const statement = `mutation CreateSpace($input: CreateSpaceInput!, $condition: ModelSpaceConditionInput) {
        createSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateSpaceMutation>response.data.createSpace;
  }
  async UpdateSpace(
    input: UpdateSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<UpdateSpaceMutation> {
    const statement = `mutation UpdateSpace($input: UpdateSpaceInput!, $condition: ModelSpaceConditionInput) {
        updateSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateSpaceMutation>response.data.updateSpace;
  }
  async DeleteSpace(
    input: DeleteSpaceInput,
    condition?: ModelSpaceConditionInput
  ): Promise<DeleteSpaceMutation> {
    const statement = `mutation DeleteSpace($input: DeleteSpaceInput!, $condition: ModelSpaceConditionInput) {
        deleteSpace(input: $input, condition: $condition) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteSpaceMutation>response.data.deleteSpace;
  }
  async CreateZone(
    input: CreateZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<CreateZoneMutation> {
    const statement = `mutation CreateZone($input: CreateZoneInput!, $condition: ModelZoneConditionInput) {
        createZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateZoneMutation>response.data.createZone;
  }
  async UpdateZone(
    input: UpdateZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<UpdateZoneMutation> {
    const statement = `mutation UpdateZone($input: UpdateZoneInput!, $condition: ModelZoneConditionInput) {
        updateZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateZoneMutation>response.data.updateZone;
  }
  async DeleteZone(
    input: DeleteZoneInput,
    condition?: ModelZoneConditionInput
  ): Promise<DeleteZoneMutation> {
    const statement = `mutation DeleteZone($input: DeleteZoneInput!, $condition: ModelZoneConditionInput) {
        deleteZone(input: $input, condition: $condition) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteZoneMutation>response.data.deleteZone;
  }
  async CreateLayer(
    input: CreateLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<CreateLayerMutation> {
    const statement = `mutation CreateLayer($input: CreateLayerInput!, $condition: ModelLayerConditionInput) {
        createLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateLayerMutation>response.data.createLayer;
  }
  async UpdateLayer(
    input: UpdateLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<UpdateLayerMutation> {
    const statement = `mutation UpdateLayer($input: UpdateLayerInput!, $condition: ModelLayerConditionInput) {
        updateLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateLayerMutation>response.data.updateLayer;
  }
  async DeleteLayer(
    input: DeleteLayerInput,
    condition?: ModelLayerConditionInput
  ): Promise<DeleteLayerMutation> {
    const statement = `mutation DeleteLayer($input: DeleteLayerInput!, $condition: ModelLayerConditionInput) {
        deleteLayer(input: $input, condition: $condition) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteLayerMutation>response.data.deleteLayer;
  }
  async CreateNavigation(
    input: CreateNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<CreateNavigationMutation> {
    const statement = `mutation CreateNavigation($input: CreateNavigationInput!, $condition: ModelNavigationConditionInput) {
        createNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNavigationMutation>response.data.createNavigation;
  }
  async UpdateNavigation(
    input: UpdateNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<UpdateNavigationMutation> {
    const statement = `mutation UpdateNavigation($input: UpdateNavigationInput!, $condition: ModelNavigationConditionInput) {
        updateNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNavigationMutation>response.data.updateNavigation;
  }
  async DeleteNavigation(
    input: DeleteNavigationInput,
    condition?: ModelNavigationConditionInput
  ): Promise<DeleteNavigationMutation> {
    const statement = `mutation DeleteNavigation($input: DeleteNavigationInput!, $condition: ModelNavigationConditionInput) {
        deleteNavigation(input: $input, condition: $condition) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNavigationMutation>response.data.deleteNavigation;
  }
  async CreatePOI(
    input: CreatePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<CreatePOIMutation> {
    const statement = `mutation CreatePOI($input: CreatePOIInput!, $condition: ModelPOIConditionInput) {
        createPOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePOIMutation>response.data.createPOI;
  }
  async UpdatePOI(
    input: UpdatePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<UpdatePOIMutation> {
    const statement = `mutation UpdatePOI($input: UpdatePOIInput!, $condition: ModelPOIConditionInput) {
        updatePOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePOIMutation>response.data.updatePOI;
  }
  async DeletePOI(
    input: DeletePOIInput,
    condition?: ModelPOIConditionInput
  ): Promise<DeletePOIMutation> {
    const statement = `mutation DeletePOI($input: DeletePOIInput!, $condition: ModelPOIConditionInput) {
        deletePOI(input: $input, condition: $condition) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePOIMutation>response.data.deletePOI;
  }
  async CreatePlan(
    input: CreatePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<CreatePlanMutation> {
    const statement = `mutation CreatePlan($input: CreatePlanInput!, $condition: ModelPlanConditionInput) {
        createPlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreatePlanMutation>response.data.createPlan;
  }
  async UpdatePlan(
    input: UpdatePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<UpdatePlanMutation> {
    const statement = `mutation UpdatePlan($input: UpdatePlanInput!, $condition: ModelPlanConditionInput) {
        updatePlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdatePlanMutation>response.data.updatePlan;
  }
  async DeletePlan(
    input: DeletePlanInput,
    condition?: ModelPlanConditionInput
  ): Promise<DeletePlanMutation> {
    const statement = `mutation DeletePlan($input: DeletePlanInput!, $condition: ModelPlanConditionInput) {
        deletePlan(input: $input, condition: $condition) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeletePlanMutation>response.data.deletePlan;
  }
  async CreateProfile(
    input: CreateProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<CreateProfileMutation> {
    const statement = `mutation CreateProfile($input: CreateProfileInput!, $condition: ModelProfileConditionInput) {
        createProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateProfileMutation>response.data.createProfile;
  }
  async UpdateProfile(
    input: UpdateProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<UpdateProfileMutation> {
    const statement = `mutation UpdateProfile($input: UpdateProfileInput!, $condition: ModelProfileConditionInput) {
        updateProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateProfileMutation>response.data.updateProfile;
  }
  async DeleteProfile(
    input: DeleteProfileInput,
    condition?: ModelProfileConditionInput
  ): Promise<DeleteProfileMutation> {
    const statement = `mutation DeleteProfile($input: DeleteProfileInput!, $condition: ModelProfileConditionInput) {
        deleteProfile(input: $input, condition: $condition) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteProfileMutation>response.data.deleteProfile;
  }
  async CreateOrganisation(
    input: CreateOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<CreateOrganisationMutation> {
    const statement = `mutation CreateOrganisation($input: CreateOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        createOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateOrganisationMutation>response.data.createOrganisation;
  }
  async UpdateOrganisation(
    input: UpdateOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<UpdateOrganisationMutation> {
    const statement = `mutation UpdateOrganisation($input: UpdateOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        updateOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateOrganisationMutation>response.data.updateOrganisation;
  }
  async DeleteOrganisation(
    input: DeleteOrganisationInput,
    condition?: ModelOrganisationConditionInput
  ): Promise<DeleteOrganisationMutation> {
    const statement = `mutation DeleteOrganisation($input: DeleteOrganisationInput!, $condition: ModelOrganisationConditionInput) {
        deleteOrganisation(input: $input, condition: $condition) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteOrganisationMutation>response.data.deleteOrganisation;
  }
  async CreateMission(
    input: CreateMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<CreateMissionMutation> {
    const statement = `mutation CreateMission($input: CreateMissionInput!, $condition: ModelMissionConditionInput) {
        createMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateMissionMutation>response.data.createMission;
  }
  async UpdateMission(
    input: UpdateMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<UpdateMissionMutation> {
    const statement = `mutation UpdateMission($input: UpdateMissionInput!, $condition: ModelMissionConditionInput) {
        updateMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateMissionMutation>response.data.updateMission;
  }
  async DeleteMission(
    input: DeleteMissionInput,
    condition?: ModelMissionConditionInput
  ): Promise<DeleteMissionMutation> {
    const statement = `mutation DeleteMission($input: DeleteMissionInput!, $condition: ModelMissionConditionInput) {
        deleteMission(input: $input, condition: $condition) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteMissionMutation>response.data.deleteMission;
  }
  async GetRoom(id: string): Promise<GetRoomQuery> {
    const statement = `query GetRoom($id: ID!) {
        getRoom(id: $id) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetRoomQuery>response.data.getRoom;
  }
  async ListRooms(
    filter?: ModelRoomFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListRoomsQuery> {
    const statement = `query ListRooms($filter: ModelRoomFilterInput, $limit: Int, $nextToken: String) {
        listRooms(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            externalID
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            internalRoomType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListRoomsQuery>response.data.listRooms;
  }
  async RoomsBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelRoomFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<RoomsBySpaceQuery> {
    const statement = `query RoomsBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelRoomFilterInput, $limit: Int, $nextToken: String) {
        roomsBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            externalID
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            internalRoomType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RoomsBySpaceQuery>response.data.roomsBySpace;
  }
  async RoomsByExternalIDBySpace(
    externalID: string,
    spaceID?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelRoomFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<RoomsByExternalIDBySpaceQuery> {
    const statement = `query RoomsByExternalIDBySpace($externalID: String!, $spaceID: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelRoomFilterInput, $limit: Int, $nextToken: String) {
        roomsByExternalIDBySpace(externalID: $externalID, spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            title
            description
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            externalID
            pois {
              __typename
              items {
                __typename
                id
                coordinate
                specific
                private
                global
                type
                elementID
                level
                role
                category
                metadata
                tagIcon
                tagDescription
                tagImageID
                matterportSweepID
                createdAt
                updatedAt
              }
              nextToken
            }
            internalRoomType
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      externalID
    };
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RoomsByExternalIDBySpaceQuery>(
      response.data.roomsByExternalIDBySpace
    );
  }
  async GetRoomType(id: string): Promise<GetRoomTypeQuery> {
    const statement = `query GetRoomType($id: ID!) {
        getRoomType(id: $id) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetRoomTypeQuery>response.data.getRoomType;
  }
  async ListRoomTypes(
    filter?: ModelRoomTypeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListRoomTypesQuery> {
    const statement = `query ListRoomTypes($filter: ModelRoomTypeFilterInput, $limit: Int, $nextToken: String) {
        listRoomTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            externalID
            title
            description
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            nbPersonsMin
            nbPersonsMax
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListRoomTypesQuery>response.data.listRoomTypes;
  }
  async RoomTypesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelRoomTypeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<RoomTypesBySpaceQuery> {
    const statement = `query RoomTypesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelRoomTypeFilterInput, $limit: Int, $nextToken: String) {
        roomTypesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            externalID
            title
            description
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            nbPersonsMin
            nbPersonsMax
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <RoomTypesBySpaceQuery>response.data.roomTypesBySpace;
  }
  async GetReservationPost(id: string): Promise<GetReservationPostQuery> {
    const statement = `query GetReservationPost($id: ID!) {
        getReservationPost(id: $id) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetReservationPostQuery>response.data.getReservationPost;
  }
  async ListReservationPosts(
    filter?: ModelReservationPostFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListReservationPostsQuery> {
    const statement = `query ListReservationPosts($filter: ModelReservationPostFilterInput, $limit: Int, $nextToken: String) {
        listReservationPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            externalID
            reservationThais {
              __typename
              checkin
              checkout
              comment
              customer_civility_id
              customer_firstname
              customer_lastname
              customer_email
              customer_phone
              customer_mobile
              customer_zipcode
              customer_city
              customer_address
              customer_country
              channel_name
              payment_type
              payment_amount
              insurance_amount
              booking_rooms {
                __typename
                room_id
                room_type_id
                rate_id
                price
              }
            }
            roomThais
            stripeSessionID
            stripePaymentStatus
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListReservationPostsQuery>response.data.listReservationPosts;
  }
  async ReservationsByStripeSession(
    stripeSessionID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelReservationPostFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ReservationsByStripeSessionQuery> {
    const statement = `query ReservationsByStripeSession($stripeSessionID: String!, $sortDirection: ModelSortDirection, $filter: ModelReservationPostFilterInput, $limit: Int, $nextToken: String) {
        reservationsByStripeSession(stripeSessionID: $stripeSessionID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            externalID
            reservationThais {
              __typename
              checkin
              checkout
              comment
              customer_civility_id
              customer_firstname
              customer_lastname
              customer_email
              customer_phone
              customer_mobile
              customer_zipcode
              customer_city
              customer_address
              customer_country
              channel_name
              payment_type
              payment_amount
              insurance_amount
              booking_rooms {
                __typename
                room_id
                room_type_id
                rate_id
                price
              }
            }
            roomThais
            stripeSessionID
            stripePaymentStatus
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      stripeSessionID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ReservationsByStripeSessionQuery>(
      response.data.reservationsByStripeSession
    );
  }
  async GetCapture(id: string): Promise<GetCaptureQuery> {
    const statement = `query GetCapture($id: ID!) {
        getCapture(id: $id) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetCaptureQuery>response.data.getCapture;
  }
  async ListCaptures(
    id?: string,
    filter?: ModelCaptureFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListCapturesQuery> {
    const statement = `query ListCaptures($id: ID, $filter: ModelCaptureFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listCaptures(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListCapturesQuery>response.data.listCaptures;
  }
  async CapturesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelCaptureFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<CapturesBySpaceQuery> {
    const statement = `query CapturesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelCaptureFilterInput, $limit: Int, $nextToken: String) {
        capturesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CapturesBySpaceQuery>response.data.capturesBySpace;
  }
  async GetNode(id: string): Promise<GetNodeQuery> {
    const statement = `query GetNode($id: ID!) {
        getNode(id: $id) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNodeQuery>response.data.getNode;
  }
  async ListNodes(
    filter?: ModelNodeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNodesQuery> {
    const statement = `query ListNodes($filter: ModelNodeFilterInput, $limit: Int, $nextToken: String) {
        listNodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNodesQuery>response.data.listNodes;
  }
  async NodesByCapture(
    captureID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelNodeFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NodesByCaptureQuery> {
    const statement = `query NodesByCapture($captureID: ID!, $sortDirection: ModelSortDirection, $filter: ModelNodeFilterInput, $limit: Int, $nextToken: String) {
        nodesByCapture(captureID: $captureID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      captureID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NodesByCaptureQuery>response.data.nodesByCapture;
  }
  async GetSpace(id: string): Promise<GetSpaceQuery> {
    const statement = `query GetSpace($id: ID!) {
        getSpace(id: $id) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetSpaceQuery>response.data.getSpace;
  }
  async ListSpaces(
    id?: string,
    filter?: ModelSpaceFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListSpacesQuery> {
    const statement = `query ListSpaces($id: ID, $filter: ModelSpaceFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listSpaces(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListSpacesQuery>response.data.listSpaces;
  }
  async SpacesByOrganisation(
    organisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelSpaceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<SpacesByOrganisationQuery> {
    const statement = `query SpacesByOrganisation($organisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelSpaceFilterInput, $limit: Int, $nextToken: String) {
        spacesByOrganisation(organisationID: $organisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SpacesByOrganisationQuery>response.data.spacesByOrganisation;
  }
  async SpacesByStripeAccount(
    connectedAccountStripeID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelSpaceFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<SpacesByStripeAccountQuery> {
    const statement = `query SpacesByStripeAccount($connectedAccountStripeID: String!, $sortDirection: ModelSortDirection, $filter: ModelSpaceFilterInput, $limit: Int, $nextToken: String) {
        spacesByStripeAccount(connectedAccountStripeID: $connectedAccountStripeID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      connectedAccountStripeID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <SpacesByStripeAccountQuery>response.data.spacesByStripeAccount;
  }
  async GetZone(id: string): Promise<GetZoneQuery> {
    const statement = `query GetZone($id: ID!) {
        getZone(id: $id) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetZoneQuery>response.data.getZone;
  }
  async ListZones(
    id?: string,
    filter?: ModelZoneFilterInput,
    limit?: number,
    nextToken?: string,
    sortDirection?: ModelSortDirection
  ): Promise<ListZonesQuery> {
    const statement = `query ListZones($id: ID, $filter: ModelZoneFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
        listZones(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
          __typename
          items {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (id) {
      gqlAPIServiceArguments.id = id;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListZonesQuery>response.data.listZones;
  }
  async ZonesBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelZoneFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ZonesBySpaceQuery> {
    const statement = `query ZonesBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelZoneFilterInput, $limit: Int, $nextToken: String) {
        zonesBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ZonesBySpaceQuery>response.data.zonesBySpace;
  }
  async GetLayer(id: string): Promise<GetLayerQuery> {
    const statement = `query GetLayer($id: ID!) {
        getLayer(id: $id) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetLayerQuery>response.data.getLayer;
  }
  async ListLayers(
    filter?: ModelLayerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListLayersQuery> {
    const statement = `query ListLayers($filter: ModelLayerFilterInput, $limit: Int, $nextToken: String) {
        listLayers(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListLayersQuery>response.data.listLayers;
  }
  async LayersByOrganisation(
    organisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelLayerFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<LayersByOrganisationQuery> {
    const statement = `query LayersByOrganisation($organisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelLayerFilterInput, $limit: Int, $nextToken: String) {
        layersByOrganisation(organisationID: $organisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <LayersByOrganisationQuery>response.data.layersByOrganisation;
  }
  async GetNavigation(id: string): Promise<GetNavigationQuery> {
    const statement = `query GetNavigation($id: ID!) {
        getNavigation(id: $id) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNavigationQuery>response.data.getNavigation;
  }
  async ListNavigations(
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNavigationsQuery> {
    const statement = `query ListNavigations($filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        listNavigations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNavigationsQuery>response.data.listNavigations;
  }
  async NavigationsByMatterportIDBySpace(
    matterportSweepID: string,
    spaceID?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NavigationsByMatterportIDBySpaceQuery> {
    const statement = `query NavigationsByMatterportIDBySpace($matterportSweepID: String!, $spaceID: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        navigationsByMatterportIDBySpace(matterportSweepID: $matterportSweepID, spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      matterportSweepID
    };
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NavigationsByMatterportIDBySpaceQuery>(
      response.data.navigationsByMatterportIDBySpace
    );
  }
  async NavigationsByNode(
    nodeID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelNavigationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<NavigationsByNodeQuery> {
    const statement = `query NavigationsByNode($nodeID: ID!, $sortDirection: ModelSortDirection, $filter: ModelNavigationFilterInput, $limit: Int, $nextToken: String) {
        navigationsByNode(nodeID: $nodeID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      nodeID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <NavigationsByNodeQuery>response.data.navigationsByNode;
  }
  async GetPOI(id: string): Promise<GetPOIQuery> {
    const statement = `query GetPOI($id: ID!) {
        getPOI(id: $id) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPOIQuery>response.data.getPOI;
  }
  async ListPOIS(
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPOISQuery> {
    const statement = `query ListPOIS($filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        listPOIS(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPOISQuery>response.data.listPOIS;
  }
  async PoisByType(
    type: PoiType,
    sortDirection?: ModelSortDirection,
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PoisByTypeQuery> {
    const statement = `query PoisByType($type: PoiType!, $sortDirection: ModelSortDirection, $filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        poisByType(type: $type, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      type
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PoisByTypeQuery>response.data.poisByType;
  }
  async PoisByElement(
    elementID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPOIFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PoisByElementQuery> {
    const statement = `query PoisByElement($elementID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPOIFilterInput, $limit: Int, $nextToken: String) {
        poisByElement(elementID: $elementID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            coordinate
            specific
            private
            global
            type
            elementID
            level
            role
            category
            metadata
            tagIcon
            tagDescription
            tagImageID
            matterportSweepID
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      elementID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PoisByElementQuery>response.data.poisByElement;
  }
  async GetPlan(id: string): Promise<GetPlanQuery> {
    const statement = `query GetPlan($id: ID!) {
        getPlan(id: $id) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetPlanQuery>response.data.getPlan;
  }
  async ListPlans(
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListPlansQuery> {
    const statement = `query ListPlans($filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        listPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListPlansQuery>response.data.listPlans;
  }
  async PlansByZone(
    zoneID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PlansByZoneQuery> {
    const statement = `query PlansByZone($zoneID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        plansByZone(zoneID: $zoneID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PlansByZoneQuery>response.data.plansByZone;
  }
  async PlansBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelPlanFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<PlansBySpaceQuery> {
    const statement = `query PlansBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelPlanFilterInput, $limit: Int, $nextToken: String) {
        plansBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            annexe
            calibration
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            isCurrentForZone
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            isModified
            isImportedMatterport
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <PlansBySpaceQuery>response.data.plansBySpace;
  }
  async GetProfile(id: string): Promise<GetProfileQuery> {
    const statement = `query GetProfile($id: ID!) {
        getProfile(id: $id) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetProfileQuery>response.data.getProfile;
  }
  async ListProfiles(
    filter?: ModelProfileFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListProfilesQuery> {
    const statement = `query ListProfiles($filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
        listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListProfilesQuery>response.data.listProfiles;
  }
  async ProfilesByUserID(
    userID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelProfileFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ProfilesByUserIDQuery> {
    const statement = `query ProfilesByUserID($userID: String!, $sortDirection: ModelSortDirection, $filter: ModelProfileFilterInput, $limit: Int, $nextToken: String) {
        profilesByUserID(userID: $userID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ProfilesByUserIDQuery>response.data.profilesByUserID;
  }
  async GetOrganisation(id: string): Promise<GetOrganisationQuery> {
    const statement = `query GetOrganisation($id: ID!) {
        getOrganisation(id: $id) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetOrganisationQuery>response.data.getOrganisation;
  }
  async ListOrganisations(
    filter?: ModelOrganisationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListOrganisationsQuery> {
    const statement = `query ListOrganisations($filter: ModelOrganisationFilterInput, $limit: Int, $nextToken: String) {
        listOrganisations(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListOrganisationsQuery>response.data.listOrganisations;
  }
  async GetMission(id: string): Promise<GetMissionQuery> {
    const statement = `query GetMission($id: ID!) {
        getMission(id: $id) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetMissionQuery>response.data.getMission;
  }
  async ListMissions(
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListMissionsQuery> {
    const statement = `query ListMissions($filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        listMissions(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListMissionsQuery>response.data.listMissions;
  }
  async MissionsByOrderedOrganisationBySpace(
    orderedOrganisationID: string,
    spaceID?: ModelIDKeyConditionInput,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByOrderedOrganisationBySpaceQuery> {
    const statement = `query MissionsByOrderedOrganisationBySpace($orderedOrganisationID: ID!, $spaceID: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByOrderedOrganisationBySpace(orderedOrganisationID: $orderedOrganisationID, spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      orderedOrganisationID
    };
    if (spaceID) {
      gqlAPIServiceArguments.spaceID = spaceID;
    }
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByOrderedOrganisationBySpaceQuery>(
      response.data.missionsByOrderedOrganisationBySpace
    );
  }
  async MissionsByOrganisation(
    organisationID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByOrganisationQuery> {
    const statement = `query MissionsByOrganisation($organisationID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByOrganisation(organisationID: $organisationID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      organisationID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByOrganisationQuery>response.data.missionsByOrganisation;
  }
  async MissionsByUser(
    userID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByUserQuery> {
    const statement = `query MissionsByUser($userID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByUser(userID: $userID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      userID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByUserQuery>response.data.missionsByUser;
  }
  async MissionsBySpace(
    spaceID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsBySpaceQuery> {
    const statement = `query MissionsBySpace($spaceID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsBySpace(spaceID: $spaceID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      spaceID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsBySpaceQuery>response.data.missionsBySpace;
  }
  async MissionsByZone(
    zoneID: string,
    sortDirection?: ModelSortDirection,
    filter?: ModelMissionFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<MissionsByZoneQuery> {
    const statement = `query MissionsByZone($zoneID: ID!, $sortDirection: ModelSortDirection, $filter: ModelMissionFilterInput, $limit: Int, $nextToken: String) {
        missionsByZone(zoneID: $zoneID, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            level
            role
            emailStatus
            description
            metadata
            groups
            deletedAt
            startDateTime
            endDateTime
            hashtags
            orderedOrganisationID
            orderedOrganisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            userID
            user {
              __typename
              id
              userID
              avatar
              token
              tokenExpiredAt
              status
              metadata
              deletedAt
              lastConnectedAt
              pseudo
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            zoneID
            zone {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            navigationID
            locale
            createdAt
            updatedAt
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {
      zoneID
    };
    if (sortDirection) {
      gqlAPIServiceArguments.sortDirection = sortDirection;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <MissionsByZoneQuery>response.data.missionsByZone;
  }
  OnCreateRoomListener(
    filter?: ModelSubscriptionRoomFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateRoom">>
  > {
    const statement = `subscription OnCreateRoom($filter: ModelSubscriptionRoomFilterInput) {
        onCreateRoom(filter: $filter) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateRoom">>
    >;
  }

  OnUpdateRoomListener(
    filter?: ModelSubscriptionRoomFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateRoom">>
  > {
    const statement = `subscription OnUpdateRoom($filter: ModelSubscriptionRoomFilterInput) {
        onUpdateRoom(filter: $filter) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateRoom">>
    >;
  }

  OnDeleteRoomListener(
    filter?: ModelSubscriptionRoomFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteRoom">>
  > {
    const statement = `subscription OnDeleteRoom($filter: ModelSubscriptionRoomFilterInput) {
        onDeleteRoom(filter: $filter) {
          __typename
          id
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          externalID
          pois {
            __typename
            items {
              __typename
              id
              coordinate
              specific
              private
              global
              type
              elementID
              level
              role
              category
              metadata
              tagIcon
              tagDescription
              tagImageID
              matterportSweepID
              createdAt
              updatedAt
            }
            nextToken
          }
          internalRoomType
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteRoom">>
    >;
  }

  OnCreateRoomTypeListener(
    filter?: ModelSubscriptionRoomTypeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateRoomType">>
  > {
    const statement = `subscription OnCreateRoomType($filter: ModelSubscriptionRoomTypeFilterInput) {
        onCreateRoomType(filter: $filter) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateRoomType">>
    >;
  }

  OnUpdateRoomTypeListener(
    filter?: ModelSubscriptionRoomTypeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateRoomType">>
  > {
    const statement = `subscription OnUpdateRoomType($filter: ModelSubscriptionRoomTypeFilterInput) {
        onUpdateRoomType(filter: $filter) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateRoomType">>
    >;
  }

  OnDeleteRoomTypeListener(
    filter?: ModelSubscriptionRoomTypeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteRoomType">>
  > {
    const statement = `subscription OnDeleteRoomType($filter: ModelSubscriptionRoomTypeFilterInput) {
        onDeleteRoomType(filter: $filter) {
          __typename
          id
          externalID
          title
          description
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          nbPersonsMin
          nbPersonsMax
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteRoomType">>
    >;
  }

  OnCreateReservationPostListener(
    filter?: ModelSubscriptionReservationPostFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onCreateReservationPost">
    >
  > {
    const statement = `subscription OnCreateReservationPost($filter: ModelSubscriptionReservationPostFilterInput) {
        onCreateReservationPost(filter: $filter) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateReservationPost">
      >
    >;
  }

  OnUpdateReservationPostListener(
    filter?: ModelSubscriptionReservationPostFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onUpdateReservationPost">
    >
  > {
    const statement = `subscription OnUpdateReservationPost($filter: ModelSubscriptionReservationPostFilterInput) {
        onUpdateReservationPost(filter: $filter) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateReservationPost">
      >
    >;
  }

  OnDeleteReservationPostListener(
    filter?: ModelSubscriptionReservationPostFilterInput
  ): Observable<
    SubscriptionResponse<
      Pick<__SubscriptionContainer, "onDeleteReservationPost">
    >
  > {
    const statement = `subscription OnDeleteReservationPost($filter: ModelSubscriptionReservationPostFilterInput) {
        onDeleteReservationPost(filter: $filter) {
          __typename
          id
          externalID
          reservationThais {
            __typename
            checkin
            checkout
            comment
            customer_civility_id
            customer_firstname
            customer_lastname
            customer_email
            customer_phone
            customer_mobile
            customer_zipcode
            customer_city
            customer_address
            customer_country
            channel_name
            payment_type
            payment_amount
            insurance_amount
            booking_rooms {
              __typename
              room_id
              room_type_id
              rate_id
              price
              nb_persons {
                __typename
                adults
                children
              }
              extras {
                __typename
                article_id
                label
                quantity
                unit_price_incl
                date
              }
            }
          }
          roomThais
          stripeSessionID
          stripePaymentStatus
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteReservationPost">
      >
    >;
  }

  OnCreateCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCapture">>
  > {
    const statement = `subscription OnCreateCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onCreateCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateCapture">>
    >;
  }

  OnUpdateCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCapture">>
  > {
    const statement = `subscription OnUpdateCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onUpdateCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateCapture">>
    >;
  }

  OnDeleteCaptureListener(
    filter?: ModelSubscriptionCaptureFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCapture">>
  > {
    const statement = `subscription OnDeleteCapture($filter: ModelSubscriptionCaptureFilterInput) {
        onDeleteCapture(filter: $filter) {
          __typename
          id
          clientRef
          originCoordinate
          originAngle
          originZoom
          takenAt
          viewer
          publishedAt
          surface
          metadata
          spaceID
          nodes {
            __typename
            items {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteCapture">>
    >;
  }

  OnCreateNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNode">>
  > {
    const statement = `subscription OnCreateNode($filter: ModelSubscriptionNodeFilterInput) {
        onCreateNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNode">>
    >;
  }

  OnUpdateNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNode">>
  > {
    const statement = `subscription OnUpdateNode($filter: ModelSubscriptionNodeFilterInput) {
        onUpdateNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNode">>
    >;
  }

  OnDeleteNodeListener(
    filter?: ModelSubscriptionNodeFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNode">>
  > {
    const statement = `subscription OnDeleteNode($filter: ModelSubscriptionNodeFilterInput) {
        onDeleteNode(filter: $filter) {
          __typename
          id
          model3D
          coordinate
          size
          scale
          version
          active
          order
          quality
          metadata
          captureID
          capture {
            __typename
            id
            clientRef
            originCoordinate
            originAngle
            originZoom
            takenAt
            viewer
            publishedAt
            surface
            metadata
            spaceID
            nodes {
              __typename
              items {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          inventoryStatus
          navigationForInventory
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNode">>
    >;
  }

  OnCreateSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSpace">>
  > {
    const statement = `subscription OnCreateSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onCreateSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateSpace">>
    >;
  }

  OnUpdateSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSpace">>
  > {
    const statement = `subscription OnUpdateSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onUpdateSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateSpace">>
    >;
  }

  OnDeleteSpaceListener(
    filter?: ModelSubscriptionSpaceFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSpace">>
  > {
    const statement = `subscription OnDeleteSpace($filter: ModelSubscriptionSpaceFilterInput) {
        onDeleteSpace(filter: $filter) {
          __typename
          id
          name
          addresses
          annexes
          tags
          latitude
          longitude
          metadata
          level
          deletedAt
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          zones {
            __typename
            items {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            nextToken
          }
          guestLink
          description
          primaryColor
          connectedAccountStripeID
          stripeOnBoardingCompleted
          stripeChargesEnabled
          contactMail
          contactPhone
          contactSiteWeb
          pmsMetadata
          pmsName
          urlCustomReservationForm {
            __typename
            locale
            data
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteSpace">>
    >;
  }

  OnCreateZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateZone">>
  > {
    const statement = `subscription OnCreateZone($filter: ModelSubscriptionZoneFilterInput) {
        onCreateZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateZone">>
    >;
  }

  OnUpdateZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateZone">>
  > {
    const statement = `subscription OnUpdateZone($filter: ModelSubscriptionZoneFilterInput) {
        onUpdateZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateZone">>
    >;
  }

  OnDeleteZoneListener(
    filter?: ModelSubscriptionZoneFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteZone">>
  > {
    const statement = `subscription OnDeleteZone($filter: ModelSubscriptionZoneFilterInput) {
        onDeleteZone(filter: $filter) {
          __typename
          id
          name
          tags
          surface
          metadata
          parentID
          parent {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          layerID
          layer {
            __typename
            id
            name
            slug
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          isMuseumVisitZone
          sweepIDs
          nodeIDs
          isMultipleFloorZone
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteZone">>
    >;
  }

  OnCreateLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateLayer">>
  > {
    const statement = `subscription OnCreateLayer($filter: ModelSubscriptionLayerFilterInput) {
        onCreateLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateLayer">>
    >;
  }

  OnUpdateLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateLayer">>
  > {
    const statement = `subscription OnUpdateLayer($filter: ModelSubscriptionLayerFilterInput) {
        onUpdateLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateLayer">>
    >;
  }

  OnDeleteLayerListener(
    filter?: ModelSubscriptionLayerFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteLayer">>
  > {
    const statement = `subscription OnDeleteLayer($filter: ModelSubscriptionLayerFilterInput) {
        onDeleteLayer(filter: $filter) {
          __typename
          id
          name
          slug
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteLayer">>
    >;
  }

  OnCreateNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNavigation">>
  > {
    const statement = `subscription OnCreateNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onCreateNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateNavigation">>
    >;
  }

  OnUpdateNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNavigation">>
  > {
    const statement = `subscription OnUpdateNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onUpdateNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateNavigation">>
    >;
  }

  OnDeleteNavigationListener(
    filter?: ModelSubscriptionNavigationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNavigation">>
  > {
    const statement = `subscription OnDeleteNavigation($filter: ModelSubscriptionNavigationFilterInput) {
        onDeleteNavigation(filter: $filter) {
          __typename
          id
          matterportSweepID
          siblings {
            __typename
            id
            matterportSweepID
            siblings {
              __typename
              id
              matterportSweepID
              siblings {
                __typename
                id
                matterportSweepID
                position
                rotation
                radius
                url
                tags
                level
                nodeID
                spaceID
                positionOnPlan
                createdAt
                updatedAt
              }
              position
              rotation
              radius
              url
              tags
              level
              nodeID
              node {
                __typename
                id
                model3D
                coordinate
                size
                scale
                version
                active
                order
                quality
                metadata
                captureID
                inventoryStatus
                navigationForInventory
                createdAt
                updatedAt
              }
              spaceID
              positionOnPlan
              createdAt
              updatedAt
            }
            position
            rotation
            radius
            url
            tags
            level
            nodeID
            node {
              __typename
              id
              model3D
              coordinate
              size
              scale
              version
              active
              order
              quality
              metadata
              captureID
              capture {
                __typename
                id
                clientRef
                originCoordinate
                originAngle
                originZoom
                takenAt
                viewer
                publishedAt
                surface
                metadata
                spaceID
                createdAt
                updatedAt
              }
              inventoryStatus
              navigationForInventory
              createdAt
              updatedAt
            }
            spaceID
            positionOnPlan
            createdAt
            updatedAt
          }
          position
          rotation
          radius
          url
          tags
          level
          nodeID
          node {
            __typename
            id
            model3D
            coordinate
            size
            scale
            version
            active
            order
            quality
            metadata
            captureID
            capture {
              __typename
              id
              clientRef
              originCoordinate
              originAngle
              originZoom
              takenAt
              viewer
              publishedAt
              surface
              metadata
              spaceID
              nodes {
                __typename
                nextToken
              }
              createdAt
              updatedAt
            }
            inventoryStatus
            navigationForInventory
            createdAt
            updatedAt
          }
          spaceID
          positionOnPlan
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteNavigation">>
    >;
  }

  OnCreatePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePOI">>
  > {
    const statement = `subscription OnCreatePOI($filter: ModelSubscriptionPOIFilterInput) {
        onCreatePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePOI">>
    >;
  }

  OnUpdatePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePOI">>
  > {
    const statement = `subscription OnUpdatePOI($filter: ModelSubscriptionPOIFilterInput) {
        onUpdatePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePOI">>
    >;
  }

  OnDeletePOIListener(
    filter?: ModelSubscriptionPOIFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePOI">>
  > {
    const statement = `subscription OnDeletePOI($filter: ModelSubscriptionPOIFilterInput) {
        onDeletePOI(filter: $filter) {
          __typename
          id
          coordinate
          specific
          private
          global
          type
          elementID
          level
          role
          category
          metadata
          tagIcon
          tagDescription
          tagImageID
          matterportSweepID
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePOI">>
    >;
  }

  OnCreatePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePlan">>
  > {
    const statement = `subscription OnCreatePlan($filter: ModelSubscriptionPlanFilterInput) {
        onCreatePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreatePlan">>
    >;
  }

  OnUpdatePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePlan">>
  > {
    const statement = `subscription OnUpdatePlan($filter: ModelSubscriptionPlanFilterInput) {
        onUpdatePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdatePlan">>
    >;
  }

  OnDeletePlanListener(
    filter?: ModelSubscriptionPlanFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePlan">>
  > {
    const statement = `subscription OnDeletePlan($filter: ModelSubscriptionPlanFilterInput) {
        onDeletePlan(filter: $filter) {
          __typename
          id
          name
          annexe
          calibration
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          isCurrentForZone
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          isModified
          isImportedMatterport
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeletePlan">>
    >;
  }

  OnCreateProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProfile">>
  > {
    const statement = `subscription OnCreateProfile($filter: ModelSubscriptionProfileFilterInput) {
        onCreateProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateProfile">>
    >;
  }

  OnUpdateProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProfile">>
  > {
    const statement = `subscription OnUpdateProfile($filter: ModelSubscriptionProfileFilterInput) {
        onUpdateProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateProfile">>
    >;
  }

  OnDeleteProfileListener(
    filter?: ModelSubscriptionProfileFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProfile">>
  > {
    const statement = `subscription OnDeleteProfile($filter: ModelSubscriptionProfileFilterInput) {
        onDeleteProfile(filter: $filter) {
          __typename
          id
          userID
          avatar
          token
          tokenExpiredAt
          status
          metadata
          deletedAt
          lastConnectedAt
          pseudo
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteProfile">>
    >;
  }

  OnCreateOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateOrganisation">>
  > {
    const statement = `subscription OnCreateOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onCreateOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onCreateOrganisation">
      >
    >;
  }

  OnUpdateOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateOrganisation">>
  > {
    const statement = `subscription OnUpdateOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onUpdateOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onUpdateOrganisation">
      >
    >;
  }

  OnDeleteOrganisationListener(
    filter?: ModelSubscriptionOrganisationFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteOrganisation">>
  > {
    const statement = `subscription OnDeleteOrganisation($filter: ModelSubscriptionOrganisationFilterInput) {
        onDeleteOrganisation(filter: $filter) {
          __typename
          id
          name
          siret
          address
          city
          postal
          logoUrl
          originDate
          deletedAt
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<
        Pick<__SubscriptionContainer, "onDeleteOrganisation">
      >
    >;
  }

  OnCreateMissionListener(
    filter?: ModelSubscriptionMissionFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateMission">>
  > {
    const statement = `subscription OnCreateMission($filter: ModelSubscriptionMissionFilterInput) {
        onCreateMission(filter: $filter) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onCreateMission">>
    >;
  }

  OnUpdateMissionListener(
    filter?: ModelSubscriptionMissionFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateMission">>
  > {
    const statement = `subscription OnUpdateMission($filter: ModelSubscriptionMissionFilterInput) {
        onUpdateMission(filter: $filter) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onUpdateMission">>
    >;
  }

  OnDeleteMissionListener(
    filter?: ModelSubscriptionMissionFilterInput
  ): Observable<
    SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteMission">>
  > {
    const statement = `subscription OnDeleteMission($filter: ModelSubscriptionMissionFilterInput) {
        onDeleteMission(filter: $filter) {
          __typename
          id
          level
          role
          emailStatus
          description
          metadata
          groups
          deletedAt
          startDateTime
          endDateTime
          hashtags
          orderedOrganisationID
          orderedOrganisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          organisationID
          organisation {
            __typename
            id
            name
            siret
            address
            city
            postal
            logoUrl
            originDate
            deletedAt
            createdAt
            updatedAt
          }
          userID
          user {
            __typename
            id
            userID
            avatar
            token
            tokenExpiredAt
            status
            metadata
            deletedAt
            lastConnectedAt
            pseudo
            createdAt
            updatedAt
          }
          spaceID
          space {
            __typename
            id
            name
            addresses
            annexes
            tags
            latitude
            longitude
            metadata
            level
            deletedAt
            organisationID
            organisation {
              __typename
              id
              name
              siret
              address
              city
              postal
              logoUrl
              originDate
              deletedAt
              createdAt
              updatedAt
            }
            zones {
              __typename
              items {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              nextToken
            }
            guestLink
            description
            primaryColor
            connectedAccountStripeID
            stripeOnBoardingCompleted
            stripeChargesEnabled
            contactMail
            contactPhone
            contactSiteWeb
            pmsMetadata
            pmsName
            urlCustomReservationForm {
              __typename
              locale
              data
            }
            createdAt
            updatedAt
          }
          zoneID
          zone {
            __typename
            id
            name
            tags
            surface
            metadata
            parentID
            parent {
              __typename
              id
              name
              tags
              surface
              metadata
              parentID
              parent {
                __typename
                id
                name
                tags
                surface
                metadata
                parentID
                spaceID
                layerID
                isMuseumVisitZone
                sweepIDs
                nodeIDs
                isMultipleFloorZone
                createdAt
                updatedAt
              }
              spaceID
              space {
                __typename
                id
                name
                addresses
                annexes
                tags
                latitude
                longitude
                metadata
                level
                deletedAt
                organisationID
                guestLink
                description
                primaryColor
                connectedAccountStripeID
                stripeOnBoardingCompleted
                stripeChargesEnabled
                contactMail
                contactPhone
                contactSiteWeb
                pmsMetadata
                pmsName
                createdAt
                updatedAt
              }
              layerID
              layer {
                __typename
                id
                name
                slug
                organisationID
                createdAt
                updatedAt
              }
              isMuseumVisitZone
              sweepIDs
              nodeIDs
              isMultipleFloorZone
              createdAt
              updatedAt
            }
            spaceID
            space {
              __typename
              id
              name
              addresses
              annexes
              tags
              latitude
              longitude
              metadata
              level
              deletedAt
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              zones {
                __typename
                nextToken
              }
              guestLink
              description
              primaryColor
              connectedAccountStripeID
              stripeOnBoardingCompleted
              stripeChargesEnabled
              contactMail
              contactPhone
              contactSiteWeb
              pmsMetadata
              pmsName
              urlCustomReservationForm {
                __typename
                locale
                data
              }
              createdAt
              updatedAt
            }
            layerID
            layer {
              __typename
              id
              name
              slug
              organisationID
              organisation {
                __typename
                id
                name
                siret
                address
                city
                postal
                logoUrl
                originDate
                deletedAt
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            isMuseumVisitZone
            sweepIDs
            nodeIDs
            isMultipleFloorZone
            createdAt
            updatedAt
          }
          navigationID
          locale
          createdAt
          updatedAt
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    return API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    ) as Observable<
      SubscriptionResponse<Pick<__SubscriptionContainer, "onDeleteMission">>
    >;
  }
}
